const books = [
  {
    titel: "The Promise",
    autor: "Damon Galgut",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9781784744076/COPL/Galgut-Damon/The-Promise.jpg?sq=5",
    preis: "15.50",
    sprache: "Englisch",
    seiten: "304",
    beschreibung: `WINNER OF THE BOOKER PRIZE 2021
        Discover the powerful prizewinning story of a family in crisis.
        'Astonishing' Colm Tóibín
        The Promise charts the crash and burn of a white South African family, living on a farm outside Pretoria. The Swarts are gathering for Ma's funeral. The younger generation, Anton and Amor, detest everything the family stand for - not least the failed promise to the Black woman who has worked for them her whole life. After years of service, Salome was promised her own house, her own land... yet somehow, as each decade passes, that promise remains unfulfilled.
        The narrator's eye shifts and blinks: moving fluidly between characters, flying into their dreams; deliciously lethal in its observation. And as the country moves from old deep divisions to its new so-called fairer society, the lost promise of more than just one family hovers behind the novel's title.
        In this story of a diminished family, sharp and tender emotional truths hit home. Confident, deft and quietly powerful, The Promise is literary fiction at its finest.
        'Gorgeous and pleasurable' Tessa Hadley
        'The most important book of the last ten years' Edmund White
        'Simply: you must read it' Claire Messud`,
    kategorie: "Romane",
    "ISBN/GTIN": "978-3-630-87707-5",
    Produktart: "Buch",
    Einbandart: "Kartoniert ",
    Verlag: "Random House UK",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "17.06.2021",
    Gewicht: "304 g",
    ArtikelNr: "16393351",
    Genre: "Neu und Bestseller",
    comments: []
  },
  {
    titel: "Wir können auch anders",
    autor: "Maja Göpel",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783550201615/COPL/G%C3%B6pel-Maja/Wir-k%C3%B6nnen-auch-anders.jpg?sq=5",
    preis: "19,99",
    sprache: "Deutsch",
    seiten: "208 seiten",
    beschreibung: `Die Menschheit befindet sich in einem gewaltigen Transformationsprozess. Die Menge dessen, was anzupacken, zu reparieren und neu auszurichten ist, scheint übergroß. Wie finden wir Kompass, Kreativität und Courage, um diese Herausforderungen weniger zu bekämpfen als viel mehr zu gestalten? Und: wer ist eigentlich wir und warum ist das so wichtig?
    Die Art, wie wir leben, wird sich fundamental verändern. Bisherige Selbstverständlichkeiten in Umwelt, Wirtschaft, Politik, Gesellschaft und Technologie zerbröseln. Doch dieses Buch macht Mut: Auf Grundlage wissenschaftlicher Erkenntnisse verdeutlicht Maja Göpel, wie wir solche komplexen Entwicklungen verstehen und dieses Wissen für eine bessere Welt nutzen können. Denn in der Geschichte hat es immer wieder Große Transformationen gegeben. Sie wurden von uns Menschen ausgelöst - also können wir sie auch gestalten. Unser Fenster zur Zukunft steht offen wie nie. Mit dieser Haltung ist Strukturwandel keine Zumutung, sondern eine Chance. Es ist Zeit, dass wir - jeder Einzelne von uns, aber auch die Gesellschaft als Ganzes - uns erlauben, neu zu denken, zu träumen und eine radikale Frage stellen: Wer wollen wir sein?`,
    kategorie: "Neu und Bestseller",
    "ISBN/GTIN": "978-3-550-20161-5",
    Produktart: "Buch",
    Einbandart: "Gebunden ",
    Verlag: "Ullstein HC",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "10.03.2022",
    Gewicht: "",
    ArtikelNr: "19810368",
    Genre: "Sachbuch",
    menge:0
  },
  {
    titel: "Bevor es zu spät ist",
    autor: "Karl Lauterbach",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783737101325/COPL/Lauterbach-Karl/Bevor-es-zu-sp%C3%A4t-ist.jpg?sq=3",
    preis: "22,00",
    sprache: "Deutsch",
    seiten: "288 ",
    beschreibung: `Wir leben in einer Zeit nie da gewesener Herausforderungen. Zum ersten Mal seit Beginn der Zivilisation ist sogar das Überleben der Menschen auf dem Planeten Erde gefährdet. Der sich beschleunigende Klimawandel macht das Erreichen des 1,5-Grad-Ziels mit jedem Tag unwahrscheinlicher. Kipp-Punkte des Klimawandels werden von der Wissenschaft warnend beschrieben und trotzdem überschritten. Doch auch bei Artenschwund, weltweitem Wassermangel, Gesundheitsgefahren durch die Lebensmittelindustrie oder womöglich noch schlimmere Pandemien gilt: Die Fakten liegen längst auf dem Tisch. Warum schafft es die Politik nicht, die wissenschaftlichen Erkenntnisse in Handeln umzusetzen?
    Die Politik muss aufnahmefähiger für die Forschung sein, ja Schritt mit ihr halten - sonst werden wir, wie Karl Lauterbach zeigt, die Kontrolle über unsere Zukunft verlieren und scheitern. Kaum jemand könnte besser darlegen als Karl Lauterbach, Politiker und Wissenschaftler zugleich, warum eine Revolution des Zusammenspiels von Politik und Wissenschaft nötig ist; von welch unterschiedlichen Denk- und Herangehensweisen diese beiden Systeme bestimmt werden; und ob eine Verzahnung überhaupt möglich ist. - Ein hochdringlicher Weckruf und ein starkes Plädoyer für eine Politik, die sich der Realität stellt.`,
    kategorie: "Neu und Bestseller",
    "ISBN/GTIN": "978-3-7371-0132-5",
    Produktart: "Buch",
    Einbandart: "Gebunden ",
    Verlag: "Rowohlt",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "28.02.2022",
    Gewicht: "",
    ArtikelNr: "19798089",
    Genre: "Sachbuch",
  },
  {
    titel: "Der fürsorgliche Mr Cave",
    autor: "Matt Haig",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783426282618/COPL/Haig-Matt/Der-f%C3%BCrsorgliche-Mr-Cave.jpg?sq=4",
    preis: "20,00",
    sprache: "Deutsch",
    seiten: "256 seiten",
    beschreibung: `Wie weit geht ein Vater, um seine Tochter vor der Welt zu schützen?
    Beklemmend, bewegend und zutiefst zu Herzen gehend: Matt Haigs psychologischer Roman über die zerstörerische Kraft von Angst und Liebe.
    Wann wird Liebe zu Besessenheit?
    Drei Mal schon musste Antiquitätenhändler Terence Cave den Verlust eines geliebten Menschen verkraften: erst den Selbstmord seiner Mutter, dann den Mord an seiner Frau, und schließlich den tragischen Tod seines Sohnes Reuben. Geblieben ist ihm nur noch seine Tochter Byrony, Reubens Zwillingsschwester - und das Gefühl, dass ihm alle genommen werden, die er liebt.
    Umso verzweifelter versucht Terence nun, seine wunderschöne Tochter vor jeder Gefahr zu schützen, koste es, was es wolle! Doch die 15-jährige Byrony riskiert immer mehr, um aus dem goldenen Käfig ihres Vaters auszubrechen, und Terence muss sich fragen, ob er sie wirklich nur beschützen will?
    Mit »Der fürsorgliche Mr Cave« hat der britische Autor Matt Haig hat einen ebenso anrührenden wie erschütternden psychologischen Roman über einen Vater geschrieben, dessen Fürsorge in Besessenheit zu kippen droht.
    Die Sorgen und Nöte, die Angst-Störungen und Depressionen verursachen, kennt Matt Haig aus eigener Erfahrung.`,
    kategorie: "Neu und Bestseller",
    "ISBN/GTIN": "978-3-426-28261-8",
    Produktart: "Buch",
    Einbandart: " Gebunden",
    Verlag: "Droemer/Knaur",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "01.02.2022",
    Gewicht: "373 g",
    ArtikelNr: "19602265",
    Genre: "Belletristik",
  },
  {
    titel: "Die Afghanistan Papers",
    autor: "Craig Whitlock",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783430210744/COPL/Whitlock-Craig/Die-Afghanistan-Papers.jpg?sq=4",
    preis: "24,99",
    sprache: "Deutsch",
    seiten: "400 seiten",
    beschreibung: `Dieses Buch wird die Erinnerung an den Krieg in Afghanistan für immer verändern.
    Die bahnbrechenden Enthüllungen des Washington Post-Reporters und dreimaligen Pulitzer-Preisfinalisten Craig Whitlock zeigen eindrücklich, wie drei aufeinanderfolgende Präsidenten - Bush, Obama, Trump - und ihre militärischen Befehlshaber die weltweite Öffentlichkeit konsequent über Amerikas längsten Kriegseinsatz belogen.
    20 Jahre nach 9/11 offenbart sich die zweck- und planlose Mission, deren absehbares Scheitern viel zu lange bewusst verborgen wurde: Die Afghanistan Papers sind ein schockierender Bericht, der auch die Rückeroberung Afghanistans durch die Taliban vorwegnahm. In seinem New-York-Times-Bestseller liefert Whitlock Dokumente und eine längst überfällige Abrechnung über all das, was schiefgelaufen ist.
    Wie einst die Pentagon Papers die öffentliche Wahrnehmung des Vietnamkriegs veränderten, enthalten die Afghanistan Papers erschütternde Enthüllungen von mehr als 1.000 Personen, die wussten, dass die US-Regierung die Fakten vor Ort verzerrt darstellte und manchmal sogar erfand - von Führungskräften im Weißen Haus und Pentagon bis hin zu Ortskräften und Soldaten an der Front in Afghanistan. Sie geben offen zu, dass die Strategie der US-Regierung ein Desaster und es ein kolossaler Fehlschlag war, einen afghanischen Staat nach westlichen Standards aufbauen zu wollen. Der abrupte Abzug der internationalen Truppen aus Afghanistan im Sommer 2021 war ein weiterer fataler Fehler in der Beurteilung der Situation vor Ort, dessen jüngste Folgen Craig Whitlock in seinem aktuellen Nachwort rekapituliert.
    »Rasant und lebendig ... randvoll mit erzählenden Zitaten.« New York Times
    »Beeindruckend dokumentiert ... Nach dieser maßgeblichen Darstellung war der Afghanistankrieg ein kolossaler Fehlschlag, der schon vor Jahren hätte beendet werden sollen.« Kirkus-Review
    »Rigoros detailliert, ein herzzerreißender Blick darauf, wie Amerikas Führer beschlossen haben, ihre Fehler zu begraben und den Krieg treiben zu lassen.« Publishers Weekly
    »Craig Whitlock leuchtet die zynische Afghanistan-Politik Washingtons aus - und setzt damit Maßstäbe.« Süddeutsche Zeitung`,
    kategorie: "Neu und Bestseller",
    "ISBN/GTIN": "978-3-430-21074-4",
    Produktart: "Buch",
    Einbandart: "Gebunden ",
    Verlag: "Econ",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "29.11.2021",
    Gewicht: "610 ",
    ArtikelNr: "20599671",
    Genre: "Sachbuch",
  },
  {
    titel: "Iran - die Freiheit ist weiblich",
    autor: "Golineh Atai",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783737101189/COPL/Atai-Golineh/Iran---die-Freiheit-ist-weiblich.jpg?sq=3",
    preis: "22,00",
    sprache: "Deutsch",
    seiten: "320 seiten",
    beschreibung: `Golineh Atai war fünf Jahre alt, als sie mit ihren Eltern den Iran verließ - aber das Land und seine Entwicklung haben sie immer beschäftigt; der Iran ist ihr Herzensthema. Wie der Gottesstaat der Mullahs seit mehr als vierzig Jahren das Land im Griff hält und jede demokratische Regung erstickt, zeigt sie in ihrem Buch, das den Iran auf ganz besondere Weise porträtiert: aus dem Blickwinkel von neun Frauen. Dabei erzählt Atai, wie aus der Tochter eines Geistlichen, die um ihr Recht auf Schulbildung kämpfen musste, eine international bekannte Aktivistin wurde. Oder wie eine junge, regierungsnahe Angestellte mitten in Teheran ihr Kopftuch auszog - eine revolutionäre Tat, die unzählige Iranerinnen inspirierte. Andere berichten von Gefängnis und Flucht, vom täglichen Kampf für ein Stück Würde und darum, ihre Stimme öffentlich zu erheben oder auch nur das Haar im Wind wehen zu lassen. Sie empfinden Wut, Trauer, fühlen sich von der Welt verlassen. Sie wissen: Nur die Freiheit der Frau kann die Freiheit der Gesellschaft hervorbringen.`,
    kategorie: "Neu und Bestseller",
    "ISBN/GTIN": "978-3-7371-0118-9",
    Produktart: "Buch",
    Einbandart: "Gebunden ",
    Verlag: "Rowohlt",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "16.11.2021",
    Gewicht: "482 g",
    ArtikelNr: "19797092",
    Genre: "Sachbuch",
  },
  {
    titel: "Allein",
    autor: "Daniel Schreiber",
    image:
      "https://www.kulturkaufhaus.de/annotstream/2244027104374/COPL/Schreiber-Daniel/Allein.jpg?sq=2",
    preis: "15,99",
    sprache: "Deutsch",
    seiten: "160 ",
    beschreibung: `Was für ein Buch! Es rührt an unsere geheimsten Ängste. Dabei tröstet es uns, klug und zärtlich zugleich - wie ein Freund, der unsere Not erkennt." Gabriele von ArnimZu keiner Zeit haben so viele Menschen allein gelebt, und nie war elementarer zu spüren, wie brutal das selbstbestimmte Leben in Einsamkeit umschlagen kann. Aber kann man überhaupt glücklich sein allein? Und warum wird in einer Gesellschaft von Individualisten das Alleinleben als schambehaftetes Scheitern wahrgenommen?Im Rückgriff auf eigene Erfahrungen, philosophische und soziologische Ideen ergründet Daniel Schreiber das Spannungsverhältnis zwischen dem Wunsch nach Rückzug und Freiheit und dem nach Nähe, Liebe und Gemeinschaft. Dabei leuchtet er aus, welche Rolle Freundschaften in diesem Lebensmodell spielen: Können sie eine Antwort auf den Sinnverlust in einer krisenhaften Welt sein? Ein zutiefst erhellendes Buch über die Frage, wie wir leben wollen.`,
    kategorie: "Empfehlungen",
    "ISBN/GTIN": "978-3-446-26792-3",
    Produktart: "Buch",
    Einbandart: " Gebunden",
    Verlag: "Hanser Berlin",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "27.09.2021",
    Gewicht: "260",
    ArtikelNr: "16414389",
    Genre: "Belletristik",
  },
  {
    titel: "Renegades",
    autor: "Barack Obama",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783328602439/COPL/Obama-Barack/Renegades.jpg?sq=5",
    preis: "42,00",
    sprache: "Deutsch",
    seiten: "320 seiten",
    beschreibung: `Springsteen, Bruce, Koautor
    Besonders hochwertige Ausstattung mit exklusiven Fotos aus den Privatarchiven
    der Autoren
    Zwei Freunde über ihr Leben, über Musik und den amerikanischen Traum
    Zwei langjährige Freunde im vertrauten, eindringlichen Gespräch - über das
    Leben, die Musik und ihre anhaltende Liebe zu Amerika mit all seinen
    Herausforderungen und Widersprüchen. Die exklusiv und besonders gestaltete
    Erweiterung des erfolgreichen Higher Ground Podcasts mit über 350
    Fotografien, exklusiven Zusatzinhalten und noch nie zuvor gesehenem
    Archivmaterial.
    »Renegades: Born in the USA« ist ein sehr persönlicher, aufschlussreicher und
    unterhaltsamer Dialog zwischen Ex-Präsident Barack Obama und der Rocklegende
    Bruce Springsteen. Die beiden erörtern alle möglichen Themen - über ihre
    Herkunft und die entscheidenden Momente ihres Lebens, über Familie und
    Vaterschaft bis hin zur polarisierenden Politik ihres Landes und der
    wachsenden Kluft zwischen dem amerikanischen Traum und der amerikanischen
    Realität. Das mit zahlreichen Farbfotografien und seltenem Archivmaterial
    gestaltete Buch ist ein fesselndes und wunderbar illustriertes Porträt zweier
    Außenseitenr - der eine Schwarz, der andere weiß -, die, wie es im Titel
    »Renegades« anklingt, ihren ganz eigenen, unkonventionellen Weg gefunden
    haben, ihre persönliche Suche nach Sinn, Identität und Gemeinschaft mit der
    amerikanischen Erzählung zu verbinden.`,
    kategorie: "Empfehlungen",
    "ISBN/GTIN": "978-3-328-60243-9",
    Produktart: "Buch",
    Einbandart: " Gebunden",
    Verlag: "Penguin Verlag München",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "26.10.2021",
    Gewicht: "1517 ",
    ArtikelNr: "20282790",
    Genre: "Sachbuch",
  },
  {
    titel: "Eine Art Bescherung",
    autor: "Siegfried Lenz",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783455001990/COPL/Lenz-Siegfried/Eine-Art-Bescherung.jpg?sq=2",
    preis: "10,00",
    sprache: "Deutsch",
    seiten: "112 ",
    beschreibung: `Vieles hat sich unter Weihnachten in Masuren ereignet«, so beginnt Das Wunder von Striegeldorf, die wohl beliebteste Weihnachtserzählung von Siegfried Lenz, in der zwei Knastbrüder sich selbst beurlauben, denn wer will schon Weihnachten hinter Gittern feiern? Als sie dann aber nach einer nicht allzu heiligen Nacht versuchen, wieder zurück in ihre Zelle zu kommen, ist das gar nicht so einfach. In weiteren winterlichen Geschichten erzählt Siegfried Lenz vom Risiko, den der Beruf des Weihnachtsmannes mit sich bringt, von erbeuteter Wärme und einer wundersamen Bescherung in bitterer Kälte, und von der Armut nach dem Krieg. Und auch von Freuden und Gefahren auf zugefrorenen masurischen Seen weiß Lenz zu berichten, von Schlittenfahrten, vom Eissegeln oder vom Eisfischen. Und nebenbei erfährt der Leser auch, was man in Bollerup macht, wenn man feststellt, dass die Holzvorräte »gewissermaßen die Schwindsucht« haben, nicht etwa, weil der Ofen zu stark geheizt wurde, sondern weil ein Holzdieb sein Unwesen treibt.`,
    kategorie: "Empfehlungen",
    "ISBN/GTIN": "978-3-455-00199-0",
    Produktart: "Taschenbuch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "Atlantik Verlag",
    Erscheinungsjahr: "2017",
    Erstverkaufstag: "05.10.2017",
    Gewicht: "118",
    ArtikelNr: "1228567",
    Genre: "Belletristik",
  },
  {
    titel: "Olympia",
    autor: "Volker Kutscher",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783492318570/COPL/Kutscher-Volker/Olympia.jpg?sq=8",
    preis: "12,00",
    sprache: "Deutsch",
    seiten: "544 ",
    beschreibung: `Der überzeugendste Roman Kutschers.« DER SPIEGEL
    Während die Nazis bei Olympia 1936 eine freundliche Fassade errichten, deckt der derzeit bekannteste Kommissar des historischen Krimis ein unfassbares Komplott auf.
    In seinem achten Fall verschlägt es Gereon Rath in das olympische Dorf. Die Olympischen Spiele 1936 sollen der Welt die Harmlosigkeit der Nazis vor Augen führen. Doch bei seinen verdeckten Ermittlungen wird nicht nur für Rath immer klarer, welche gefährliche Scharade das Regime hier spielt. Zu allem Überfluss muss sich der unangepasste Kommissar auch noch mit häuslichen Problemen auseinandersetzen, denn seine Frau Charly sucht plötzlich das Weite.
    Wie kaum ein anderer Autor schafft es Volker Kutscher, mit seiner erfolgreichen Krimireihe über Kommissar Gereon Rath das Berlin während des Nationalsozialismus' lebendig werden zu lassen.
    »Atmosphärisch dicht, spannungs- und temporeich« ARD druckfrisch
    Die Gereon-Rath-Romane zählen zu den erfolgreichsten Reihen der deutschen Literaturlandschaft. Fans und Kritiker feiern die atmosphärischen und packenden Erzählungen, in denen Wahrheit und Fiktion einen Pakt mit Kutschers großem Erzähltalent schließen.
    Ein großer historischer Kriminalroman in Serie - die Vorlage für »Babylon Berlin«
    Spätestens seit dem Erfolg der TV-Serie "Babylon Berlin" ist Gereon Rath eine Ikone des historischen Kriminalromans. Für Fans von Volker Kutscher ist das keine Neuigkeit. Werfen Sie jetzt das Kopfkino an, und folgen Sie Gereon Rath durch acht packende Fälle aus dem Berlin der 20er und 30er-Jahre!`,
    kategorie: "Empfehlungen",
    "ISBN/GTIN": "978-3-492-31857-0",
    Produktart: "Buch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "Piper",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "30.09.2021",
    Gewicht: "385 ",
    ArtikelNr: "19564174",
    Genre: "Krimis",
  },
  {
    titel: "Vergissmeinnicht - Was man bei Licht nicht sehen kann",
    autor: "Kerstin Gier",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783949465000/COPL/Gier-Kerstin/Vergissmeinnicht---Was-man-bei-Licht-nicht-sehen-kann.jpg?sq=6",
    preis: "20,00",
    sprache: "Deutsch",
    seiten: "480",
    beschreibung: `Bestsellerautorin Kerstin Gier öffnet uns nach der »Edelstein«- und der »Silber«-Trilogie die Tür zu einer neuen phantastischen Welt und erzählt eine mitreißende Liebesgeschichte aus zwei Perspektiven:
    Quinn ist cool, smart und beliebt. Matilda entstammt der verhassten Nachbarsfamilie, hat eine Vorliebe für Fantasyromane und ist definitiv nicht sein Typ. Doch als Quinn eines Nachts von gruseligen Wesen verfolgt und schwer verletzt wird, sieht er Dinge, die nicht von dieser Welt sein können. Nur - wem kann man sich anvertrauen, wenn Statuen plötzlich in schlechten Reimen sprechen und Skelettschädel einem vertraulich zugrinsen? Am besten dem Mädchen von gegenüber, das einem total egal ist. Dass er und Matilda in ein magisches Abenteuer voller Gefahren katapultiert werden, war von Quinn so allerdings nicht geplant. Und noch viel weniger, sich unsterblich zu verlieben`,
    kategorie: "Empfehlungen",
    "ISBN/GTIN": "978-3-949465-00-0",
    Produktart: "Buch",
    Einbandart: "Gebunden ",
    Verlag: "S.Fischer Verlag GmbH",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "29.09.2021",
    Gewicht: "761",
    ArtikelNr: "19862005",
    Genre: "Literatur",
  },
  {
    titel: "Die Dämonen",
    autor: "Fjodor Dostojewski",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783746638997/COPL/Dostojewski-Fjodor/Die-D%C3%A4monen.jpg?sq=3",
    preis: "16,00",
    sprache: "Deutsch",
    seiten: "944 ",
    beschreibung: `Intrigen und Irrsinn.Die Generalswitwe Warwara Petrowna und der ehemalige Hauslehrer Stepan Trofimowitsch haben sich in einiger Entfernung von St. Petersburg zur Ruhe gesetzt. Unerwartet tauchen ihre inzwischen erwachsenen Söhne auf und kehren das Unterste zuoberst. Ein »revolutionäres Komitee« soll sämtliche Autoritäten stürzen. Dämonen gleich, überzieht es die Stadt mit einem Spinnennetz von Intrigen und aufrührerischen Ideen, bis alles außer Kontrolle gerät. Ein Roman über das Russland des 19. Jahrhunderts, in dem der bröckelnde Zarismus mit neuen zerstörerischen Kräften zusammenprallt.»Dostojewski ist ein Ozean bei hohem Seegang, unzuverlässigen Winden und abrupt wechselnder Temperatur`,
    kategorie: "Klassiker",
    "ISBN/GTIN": "978-3-7466-3899-7",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "Aufbau TB",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "20.09.2021",
    Gewicht: "552 ",
    ArtikelNr: "19617576",
    Genre: "Belletristik",
  },
  {
    titel: "Ungeduld des Herzens",
    autor: "Stefan Zweig",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783552058781/COPL/Zweig-Stefan/Ungeduld-des-Herzens.jpg?sq=1",
    preis: "36,00",
    sprache: "Deutsch",
    seiten: "720 ",
    beschreibung: `Dein Buch geht mir tief nach - jede Figur darin - alle Empfindungen dieser Menschen sind wahr." Alma Mahler-Werfel an Stefan Zweig, 1938Der einzige von Stefan Zweig zu Lebzeiten veröffentlichte Roman ist ein psychologisch raffiniertes Gesellschaftspanorama mit ungebrochener Anziehungskraft, das die Leserinnen und Leser in ein Netz aus Liebe, Mitleid, Schwäche und Verantwortung verstrickt. Angesiedelt im k. u. k. Offiziersmilieu kurz vor Ausbruch des Ersten Weltkriegs, kommentiert der Roman auch sein Erscheinungsjahr 1938 mit deutlichen Worten - und bietet reichlich Projektionsfläche für die Herausforderungen der Gegenwart. Erstmals werden die verschiedenen Textstufen dokumentiert und erlauben es, den Roman aus Sicht der früheren Fassungen neu zu entdecken.`,
    kategorie: "Klassiker",
    "ISBN/GTIN": "978-3-552-05878-1",
    Produktart: "Buch",
    Einbandart: "Gebunden ",
    Verlag: "Paul Zsolnay Verlag",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "25.10.2021",
    Gewicht: "604",
    ArtikelNr: "16414445",
    Genre: "Belletristik",
  },
  {
    titel: "Die Brüder Karamasow",
    autor: "Fjodor Dostojewski",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783596907328/COPL/Dostojewskij-Fjodor/Die-Br%C3%BCder-Karamasow.jpg?sq=4",
    preis: "18,00",
    sprache: "Deutsch",
    seiten: "1296",
    beschreibung: `Die Brüder Karamasow« - »Roman in vier Teilen, mit einem Epilog« ist das letzte Werk der großen »Romantragödien« von Fjodor Michailowitsch Dostojewskij, erschienen 1879/80, ein Jahr vor dem Tod seines Autors. Der Roman ist nicht nur eine packende Familiengeschichte im Russland des 19. Jahrhunderts, sondern auch ein intensives erzählerisches und gedankliches Umkreisen einer Idee: Kann die Erkenntnis des Guten inmitten von unendlich viel Bösem die Menschen erlösen?
    Wiederum als Kriminalgeschichte angelegt, diesmal jedoch bleibt der Täter für den Leser bis zum Schluss unbekannt, erzählt Dostojewskij die Geschichte der drei Brüder Karamasow, die als Erwachsene in ihr Elternhaus zurückkehren, wo sie ihrem Vater als einem alten lüsternen Trunkenbold begegnen. Ihre Verachtung ist so groß, dass sie seinen Tod herbeiwünschen. Als er dann wirklich ermordet aufgefunden wird, fällt der Verdacht auf den ältesten Bruder, Dmitrij. Er wird schuldig gesprochen und zu Zwangsarbeit in Sibirien verurteilt. Alle wissen jedoch: Ein anderer hat den greisen Unhold ermordet, und trotzdem nehmen die Brüder die Schuld auf sich ...
    Inmitten menschlicher Verirrungen und turbulenter Beziehungswirren stehen die Fragen nach dem Gesetz, dem Glauben und der Ethik - eindeutige Antworten darauf werden wir in dem Roman nicht finden, jedoch eine Beschäftigung damit, die uns über die Lektüre hinaus begleitet.
    »Von jetzt an heißt es: Fort mit euch, ihr alten Übersetzungen! Wir wollen nur den klaren, rhetorisch versierten Dostojewskij von Swetlana Geier.«
    Paul Ingendaay, Frankfurter Allgemeine Zeitung
    »Später Anfang, spektakuläres Ergebnis: Erst mit 65 Jahren fing Swetlana Geier mit der Übersetzung der großen Romane von Fjodor Dostojewskij an. Doch ihre Neubearbeitungen gelten als Meilensteine.«`,
    kategorie: "Klassiker",
    "ISBN/GTIN": "978-3-596-90732-8",
    Produktart: "Taschenbuch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "FISCHER Taschenbuch",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "24.03.2021",
    Gewicht: "805",
    ArtikelNr: "18819322",
    Genre: "Literatur",
  },
  {
    titel: "Effingers",
    autor: "Gabriele Tergit",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783442719723/COPL/Tergit-Gabriele/Effingers.jpg?sq=3",
    preis: "14,00",
    sprache: "Deutsch",
    seiten: "912 ",
    beschreibung: `Effingers« ist ein Familienroman - eine Chronik der Familie Effinger über vier Generationen hinweg. Außer dass sie Juden sind, unterscheidet sich ihr Schicksal in nichts von dem anderer gutsituierter gebildeter Bürger im Berlin der Jahrhundertwende. Alle fahren sie im sich immer wiederholenden Lebenskarussell, das sich durch Glück, Schmerz, Leichtsinn, Erfolg und Scheitern dreht. Erst als der Nationalsozialismus sich breitmacht, wird aus dem deutschen Schicksal der Effingers ein jüdisches.`,
    kategorie: "Klassiker",
    "ISBN/GTIN": "978-3-442-71972-3",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "btb",
    Erscheinungsjahr: "2020",
    Erstverkaufstag: "14.09.2020",
    Gewicht: "723",
    ArtikelNr: "16538003",
    Genre: "Literatur",
  },
  {
    titel: "Verbrechen und Strafe",
    autor: "Fjodor Dostojewski",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783596907304/COPL/Dostojewskij-Fjodor/Verbrechen-und-Strafe.jpg?sq=4",
    preis: "16,00",
    sprache: "Deutsch",
    seiten: "784 ",
    beschreibung: `Der vollkommenste Roman Dostojewskijs, einer der größten Kriminalromane der Weltliteratur - und ein grandioses Albtraumspiel.
    Raskolnikow entstammt einer verarmten bürgerlichen Familie. In der schrankähnlichen Enge seines Zimmers will er, dass allein die Ratio und der Verstand sein Leben beherrschen. Aufgrund des wissenschaftlichen oder sozialen Fortschritts scheint es ihm erlaubt, eine alte Wucherin, die »nicht besser als eine Laus ist«, zu töten und mit dem geraubten Geld sein Studium zu finanzieren. Sein Herz wehrt sich ebenso wie sein Unterbewusstsein gegen die geplante Tat, doch von sozialer Not gedrängt und gefangen in lebensfeindlichen Ideen, wird er zum Mörder. Das Delirium und die grenzenlose Einsamkeit, die dem Verbrechen folgen, lassen ihn erkennen, dass die Funktionen des Verstandes nicht die einzige bestimmende Dimension der menschlichen Persönlichkeit ausmachen. Leidvoll, aber bereichert durch die einfühlsame Scharfsicht des Untersuchungsrichters Porfirij und durch die frisch erwachte Liebe zu Sonja Marmeladowa, erfährt er, dass der Weg aus der Vereinsamung nur über Geständnis und Strafe führen kann.
    »Von jetzt an heißt es: Fort mit euch, ihr alten Übersetzungen! Wir wollen nur den klaren, rhetorisch versierten Dostojewskij von Swetlana Geier.«
    Paul Ingendaay, Frankfurter Allgemeine Zeitung
    »Später Anfang, spektakuläres Ergebnis: Erst mit 65 Jahren fing Swetlana Geier mit der Übersetzung der großen Romane von Fjodor Dostojewskij an. Doch ihre Neubearbeitungen gelten als Meilensteine.«`,
    kategorie: "Klassiker",
    "ISBN/GTIN": "978-3-596-90730-4",
    Produktart: "Taschenbuch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "FISCHER Taschenbuch",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "24.03.2021",
    Gewicht: "492 ",
    ArtikelNr: "18819263",
    Genre: "Literatur",
  },
  {
    titel: "Elementarteilchen",
    autor: "Michelle Houlebeck",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783832162788/COPL/Houellebecq-Michel/Elementarteilchen.jpg?sq=8",
    preis: "12,00",
    sprache: "Deutsch",
    seiten: "358",
    beschreibung: `Elementarteilchen' ist der unmoralische Roman eines großen Moralisten: Michel Houellebecq berichtet in präziser Sprache und mit minuziöser Sachlichkeit vom glücklosen Leben der Halbbrüder Bruno und Michel, erst in der französischen Provinz, dann in Paris. Sie teilen eine egoistisch lieblose Mutter aus der 68er Generation, die sich ihrer sexuellen Selbstverwirklichung ausschweifend widmet - und sie teilen ihre von kalter Einsamkeit geprägte lebenslange Verstörung. Bruno, der Ältere, wird zum sexmanischen Opfer seiner fanatisch-verzweifelten Obsessionen. Michel ist Molekularbiologe und verbringt sein autistisches Forscherleben zwischen Supermarkt und Psychopharmaka - bis er in einem gentechnischen Institut in Irland das unsterbliche und geschlechtslose menschliche Wesen klont - die Vision jenseits des Egoismus und sexuellen Elends. Mit Michel und Bruno entwirft Michel Houellebecq zwei Lebensläufe am »Ende der alten Ordnung«. Ein visionärer Gesellschaftsroman, voll Verachtung für den Fin-de-siècle-Materialismus und ein Abgesang auf unsere Zeit.`,
    kategorie: "Romane",
    "ISBN/GTIN": "978-3-8321-6278-8",
    Produktart: "Taschenbuch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "DuMont Buchverlag",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "16.11.2021",
    Gewicht: "",
    ArtikelNr: "1229762",
    Genre: "Belletristik",
  },
  {
    titel: "Spinnst du?",
    autor: "Sonja Kopitz",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783499004193/COPL/Koppitz-Sonja/Spinnst-du.jpg?sq=1",
    preis: "16,00",
    sprache: "Deutsch",
    seiten: "352 seiten",
    beschreibung: `Noch immer wissen wir zu wenig über den Umgang mit «lockeren Schrauben» und «langen Leitungen» - früher wurde man weggesperrt, heute heißt es «Reiß dich mal zusammen». Wie begegnen wir Menschen mit psychischen Erkrankungen? Wie kann ihnen geholfen werden - und wie geht die Gesellschaft mit ihnen um? Sonja Koppitz, selbst an einer wiederkehrenden Depression erkrankt, spricht mit Betroffenen, schildert alle Facetten psychischer Erkrankungen und wirft einen Blick hinter die Kulissen des Universums Psychiatrie, wo Tragik und Komik oft sehr nah beieinanderliegen - ihr Ansatz, Persönliches mit Information zu verbinden, ist neu und von großer Klarheit.`,
    kategorie: "Romane",
    "ISBN/GTIN": "978-3-499-00419-3",
    Produktart: "Taschenbuch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "Rowohlt TB.",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "14.12.2021",
    Gewicht: "422",
    ArtikelNr: "19798388",
    Genre: "Belletristik",
  },

  {
    titel: "Outlander - Das Schwärmen von tausend Bienen",
    autor: "Diana Gabaldon",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783426653746/COPL/Gabaldon-Diana/Outlander---Das-Schw%C3%A4rmen-von-tausend-Bienen.jpg?sq=5",
    preis: "28,00",
    sprache: "Deutsch",
    seiten: "1152 ",
    beschreibung: `Im historischen Roman »Outlander - Das Schwärmen von tausend Bienen« müssen Claire und Jamie Fraser inmitten des amerikanischen Unabhängigkeitskrieges um ihre Familie und ihre Liebe kämpfen.
    1779 steht für Claire Randall und Jamie Fraser mehr auf dem Spiel als jemals zuvor: Zwar sind sie überglücklich über Briannas Heimkehr - doch niemand weiß, ob die Gefahr, die ihre Tochter mit Mann und Kindern zur Flucht aus dem 20. Jahrhundert gezwungen hat, wirklich gebannt ist. Wie können Claire und Jamie ihrer Familie inmitten des amerikanischen Unabhängigkeitskrieges Schutz bieten?
    Währenddessen hadert der junge William Ransom noch immer mit seiner wahren Abstammung. Und Lord John Grey muss sowohl einen Weg zur Versöhnung finden, als auch neuen Gefahren entgegentreten - im Namen seines Sohnes, und in seinem eigenen ...
    Spannung und Dramatik, Leidenschaft, Liebe und Abenteuer: Seit 8 internationalen Bestsellern steht die Serie »Outlander« für einen hoch spannenden Mix aus Zeitreise-Roman und historischem Roman.
    Auch im 9. Band von »Outlander« lässt Welt-Bestseller-Autorin Diana Gabaldon uns hautnah am Schicksal von Claire und Jamie Fraser, ihrer Familie und ihren Freunden teilhaben.
    Alle Bände der "Outlander"-Reihe von Diana Gabaldon:
    - »Outlander«`,
    kategorie: "Romane",
    "ISBN/GTIN": "978-3-426-65374-6",
    Produktart: "Buch",
    Einbandart: "Mit bedrucktem Schutzumschlag ",
    Verlag: "Knaur",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "23.11.2021",
    Gewicht: "1509 ",
    ArtikelNr: "19778695",
    Genre: "Belletristik",
  },
  {
    titel: "Die Topeka Schule",
    autor: "Ben Lerner",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783518471814/COPL/Lerner-Ben/Die-Topeka-Schule.jpg?sq=17",
    preis: "12,00",
    sprache: "Deutsch",
    seiten: "395 ",
    beschreibung: `Die Topkea Schule ist die Geschichte einer Familie um die Jahrtausendwende. Die Geschichte einer Mutter, die sich von einem Missbrauch befreien will; eines Vaters, der seine Ehe verrät; eines Sohnes, dem die ganzen Rituale von Männlichkeit suspekt werden und der zunehmend verstummt. Eine Geschichte von Konflikten und Kämpfen und versuchten Versöhnungen.
    In einer an Wundern reichen Sprache erzählt Ben Lerner vom drohenden Zusammenbruch privater und öffentlicher Rede und unserer heutigen Gesellschaft - davon, wie es so weit gekommen ist und wo es mit uns hingehen könnte.`,
    kategorie: "Romane",
    "ISBN/GTIN": "978-3-518-47181-4",
    Produktart: "Taschenbuch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "Suhrkamp",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "21.11.2021",
    Gewicht: "362 ",
    ArtikelNr: "16414854",
    Genre: "Belletristik",
  },
  {
    titel: "Starlight Full Of Chances",
    autor: "Mounia Jaywand",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783736316607/COPL/Jayawanth-Mounia/Starlight-Full-Of-Chances.jpg?sq=22",
    preis: "12,90",
    sprache: "Deutsch",
    seiten: "464",
    beschreibung: `Eine besondere Nacht wird ihre Leben für immer verändern
    Vicky und Vince könnten nicht unterschiedlicher sein. Sie ist ein Freigeist, er ein Pragmatiker. Er mag es klassisch, sie alternativ. Doch Gegensätze ziehen sich an, und auch wenn die beiden es anfangs nicht wahrhaben wollen, kommen sie sich immer näher. Bis Vicky eines Tages einen Schicksalsschlag erleidet, der nicht nur ihr Leben, sondern auch ihre Zukunft mit Vince für immer verändert.
    Zweiter Band der BERLIN-NIGHT-Trilogie`,
    kategorie: "New Adult",
    "ISBN/GTIN": "978-3-7363-1660-7",
    Produktart: "Buch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "LYX",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "25.03.2022",
    Gewicht: "",
    ArtikelNr: "19689428",
    Genre: "Literatur",
  },

  {
    titel: "Sunrise Full Of Wonder",
    autor: "Mounia jajawanth",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783736316751/COPL/Jayawanth-Mounia/Sunrise-Full-Of-Wonder.jpg?sq=14",
    preis: "12,90",
    sprache: "Deutsch",
    seiten: "420 ",
    beschreibung: `Eine besondere Nacht wird ihre Leben für immer verändern
    Die besten Freunde Maya und Lennart sind immer füreinander da und trösten sich über jeden Liebeskummer hinweg. Denn viel zu oft wurden sie von anderen schon in die Friendzone verbannt. Doch als Lennart seine Wohnung verliert und bei Maya einzieht, verändert sich alles. Die beiden lernen neue seiten aneinander kennen, die unerwartet intensive Gefühle wecken: Plötzlich wird ihnen klar, dass die große Liebe vielleicht die ganze Zeit über schon ganz nah war. Aber dann werden die beiden mit einer großen Herausforderung konfrontiert, die das vermeintliche Glück auf eine schwere Probe stellt ...`,
    kategorie: "New Adult",
    "ISBN/GTIN": "978-3-7363-1675-1",
    Produktart: "Buch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "LYX",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "26.08.2022",
    Gewicht: "",
    ArtikelNr: "19686363",
    Genre: "Literatur",
  },

  {
    titel: "Worlds Beyond",
    autor: "Annabelle Stehl",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783736316874/COPL/Stehl-Anabelle/Worlds-Beyond.jpg?sq=22",
    preis: "12,90",
    sprache: "Deutsch",
    seiten: "450 ",
    beschreibung: `Er hebt ihre Welt aus den Angeln ...
    Nele Schubert hat es geschafft und ein Volontariat in einer großen PR-Agentur in London ergattert. Der junge Geschäftsführer Matthew verdreht ihr von Anfang an den Kopf, und auch er kann die Anziehung zwischen ihnen nicht leugnen. Immer wieder kommt es im Büro zu knisternden Momenten, doch Beziehungen zwischen Vorgesetzten und ihren Mitarbeitern sind eigentlich verboten. Auf keinen Fall will Nele den Job riskieren, für den sie alles gegeben hat. Aber ihre Gefühle für Matthew kann sie auch nicht einfach abstellen ...
    Band 3 der WORLDS-Reihe rund um junge Influencer:innen in London von SPIEGEL-Bestseller-Autorin Anabelle Stehl`,
    kategorie: "New Adult",
    "ISBN/GTIN": "978-3-7363-1687-4",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "LYX",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "25.11.2022",
    Gewicht: "",
    ArtikelNr: "19686843",
    Genre: "Literatur",
  },
  {
    titel: "Worlds Apart",
    autor: "Annabelle Stehl",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783736316867/COPL/Stehl-Anabelle/Worlds-Apart.jpg?sq=19",
    preis: "12,90",
    sprache: "Deutsch",
    seiten: "450 ",
    beschreibung: `hre Träume liegen Welten auseinander ...
    Die 19-jährige Kaycee Williams hat einen Traum: eine eigene Konditorei. Den stellt sie jedoch zurück, als ihre Mutter stirbt und sie sich um ihre Schwester kümmern muss. Doch dann wird Kaycee für die Show BAKE THAT CAKE! angenommen. Am Set lernt sie den gut aussehenden Schauspieler Leo Campbell kennen, der in der Jury sitzt, und zwischen den beiden prickelt es sofort. Als sie sich näherkommen, versucht die Produktionsfirma die junge Liebe für PR-Zwecke auszunutzen. Doch was bedeutet das für Kaycees Chancen in der Show? Setzt sie ihre Zukunft aufs Spiel, indem sie sich auf Leo einlässt?
    "Tiefe Gefühle, reale Schicksale und wichtige Messages - das alles habe ich an RUNAWAY geliebt." ROXYSPODCAST
    Band 2 der WORLDS-Reihe rund um junge Influencer:innen in London von SPIEGEL -Bestseller-Autorin Anabelle Stehl`,
    kategorie: "New Adult",
    "ISBN/GTIN": "978-3-7363-1686-7",
    Produktart: "Buch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "LYX",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "29.07.2022",
    Gewicht: "",
    ArtikelNr: "19687604",
    Genre: "Literatur",
  },
  {
    titel: "Drowning in Stars",
    autor: "Debra Anastasia",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783736316676/COPL/Anastasia-Debra/Drowning-in-Stars.jpg?sq=18",
    preis: "14,00",
    sprache: "Deutsch",
    seiten: "464",
    beschreibung: `Ich musste mich zwischen dir und mir entscheiden. Ich habe dich gewählt!
    Das Leben war nie einfach für Pixie und Gaze. Pixies Mutter ist nur selten zu Hause, Gaze' Vater trinkt zu viel. Aber sie haben einander - und für Gaze war eins von Anfang an klar: Pixie ist die Eine. Sie hat ihn beschützt, als er neu im Viertel war. Ohne einander wären sie untergegangen. Sie haben sich versprochen, immer zusammenzubleiben. Doch eines Tages muss sich Pixie entscheiden: für ihr Versprechen oder für Gaze' Leben. Als sie sich Jahre später wiedertreffen, ist es Gaze, der für sie beide stark sein muss. Denn nur wenn Pixie sich von ihren Dämonen befreien kann, hat ihre Liebe eine Chance ...
    "Die Tiefe der Gefühle, die ich beim Lesen empfand, war fast schmerzhaft. Doch bei all dem Herzzerreißenden war da auch so viel Liebe und Hoffnung." 25 READINGS OR MORE
    Auftakt der dramatischen New-Adult-Dilogie`,
    kategorie: "New Adult",
    "ISBN/GTIN": "978-3-7363-1667-6",
    Produktart: "Buch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "LYX",
    Erscheinungsjahr: "2021",
  },
  {
    titel: "Off the Record. Unsere Worte sind unsere Macht",
    autor: "Camryn Carret",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783401606453/COPL/Garrett-Camryn/Off-the-Record.-Unsere-Worte-sind-unsere-Macht.jpg?sq=5",
    preis: "15,00",
    sprache: "Deutsch",
    seiten: "416",
    beschreibung: `Schweigen bedeutet Unrecht.
Reden bedeutet die Gefahr, alles zu verlieren.
Für was würdest du dich entscheiden?
Schreiben ist Josies Leben. In Texten kann sie ihre Gedanken fliegen lassen und ihr inneres Sorgenkarussell anhalten. Als die 17-Jährige einen Schreibwettbewerb gewinnt, darf sie ein Filmteam auf eine Pressetour durch die USA begleiten. Doch auf der Reise erfährt Josie etwas Ungeheuerliches: Ein gefeierter Regisseur belästigt Mädchen und Frauen am Set - und kommt offenbar schon lange damit durch. Schnell wird die ersehnte Reise zu ihrer größten Herausforderung, denn was kann ein Mädchen wie sie schon ausrichten? Es gibt so viele Gründe, zu schweigen. Es gibt so viele Gründe, nichts zu sagen. Und doch muss Josie den Mut finden, den Text zu schreiben, der alles verändern wird.
In "Off the Record" gibt Camryn Garrett all den mutigen und kämpferischen Menschen ein Gesicht, die sich für Gerechtigkeit einsetzen und deren Geschichten doch zu oft unsichtbar bleiben.
"Selten habe ich einen Menschen, der sich selbst als ängstlich bezeichnet, so für seinen Mut bewundert, wie Josie Wright. Ihre Story macht Mut. Sie geht uns alle an - und dieser Roman ist ganz großes Kino." (Isabel Abedi)`,
    kategorie: "Jugendbücher",
    "ISBN/GTIN": "978-3-401-60645-3",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "Arena",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "14.10.2021",
    Gewicht: "621",
    ArtikelNr: "19538709",
    Genre: "Jugendbuch",
  },
  {
    titel: "Gregs Tagebuch 16 - Volltreffer!",
    autor: "Jeff Kiney",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783833906800/COPL/Kinney-Jeff/Gregs-Tagebuch-16---Volltreffer.jpg?sq=20",
    preis: "14,99",
    sprache: "Deutsch",
    seiten: "224 ",
    beschreibung: `Greg Heffley und Sport? Das passt einfach nicht zusammen. Nach einem fürchterlichen Trainingstag in der Schule erklärt Greg seine Sportkarriere für offiziell beendet. Doch leider hat Greg die Rechnung ohne seine Mom gemacht. Sie überredet ihn, der Sache eine letzte Chance zu geben und sich für eins der Basketballteams zu bewerben.
Wie zu erwarten, sind die Auswahlspiele ein Reinfall, und Greg ist sich sicher, dass er es mal wieder versemmelt hat. Doch dann schafft er es tatsächlich ins Team, wenn auch nur in das schlechteste der ganzen Schule. Die Saison beginnt, und die Chancen, auch nur ein Spiel zu gewinnen, sind gleich null. Aber im Sport ist alles möglich, oder? Und so bekommt Greg im entscheidenden Moment im Spiel den Ball ... Wird er über sich hinauswachsen und einen Treffer landen? Oder wird er es mal wieder vermasseln?
Gregs Tagebuch von Jeff Kinney ist eine der erfolgreichsten Kinderbuchserien der Welt. Die humorvollen Comics um Greg Heffley besitzen mittlerweile Kultstatus.`,
    kategorie: "Jugendbücher",
    "ISBN/GTIN": "978-3-8339-0680-0",
    Produktart: "Buch",
    Einbandart: "Gebunden ",
    Verlag: "Baumhaus Medien",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "13.11.2021",
    Gewicht: "",
    ArtikelNr: "19686672",
    Genre: "Jugendbuch",
  },
  {
    titel: "Lustiges Taschenbuch Weihnachten 27",
    autor: "Disney",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783841328274/COPL/Disney/Lustiges-Taschenbuch-Weihnachten-27.jpg?sq=3",
    preis: "8,50",
    sprache: "Deutsch",
    seiten: "256 ",
    beschreibung: `Der Duft von frisch gebackenen Plätzchen und grünen Tannenzweigen verrät es: Es weihnachtet in Entenhausen. Die Stadt hat sich herausgeputzt und strahlt im Lichterglanz! Und die Leute strahlen vor Vorfreude auf das Fest! Alle sind glücklich! Wirklich alle? Nein! Einer bläst Trübsal so kurz vor Heiligabend. Elbin der Elf hat lange für den Weihnachtsmann gearbeitet. Nun aber nicht mehr. Er sah sich gezwungen, die wundertätige Werkstatt am Nordpol für immer zu verlassen. Doch Tick, Trick und Track finden, niemand sollte so traurig sein müssen, erst recht nicht an Weihnachten. Können sie Elbin helfen?`,
    kategorie: "Geschenkbücher und Humor",
    "ISBN/GTIN": "978-3-8413-2827-4",
    Produktart: "Taschenbuch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "Egmont Ehapa Berlin Buch",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "02.11.2021",
    Gewicht: "",
    ArtikelNr: "19574618",
    Genre: "Comic",
  },
  {
    titel: "Muttis Rückkehr",
    autor: "Heiko Sakurai",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783946972556/COPL/Sakurai-Heiko/Muttis-R%C3%BCckkehr.jpg?sq=1",
    preis: "19,90",
    sprache: "Deutsch",
    seiten: "176",
    beschreibung: `Die besten Cartoons von Heiko Sakurai fassen das Jahr 2021 satirisch zusammen. Meisterhaft tiefsinnig und traumhaft komisch!`,
    kategorie: "Geschenkbücher und Humor",
    "ISBN/GTIN": "978-3-946972-55-6",
    Produktart: "Buch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "Schaltzeit",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "02.12.2021",
    Gewicht: "500 ",
    ArtikelNr: "19979780",
    Genre: "Comic",
  },
  {
    titel: "Deutschland Was Geht",
    autor: "Hazel Brugger",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783257012941/COPL/Brugger-Hazel/Deutschland-Was-Geht.jpg?sq=7",
    preis: "14,00",
    sprache: "Deutsch",
    seiten: "16 ",
    beschreibung: `Ob auf der Straußenfarm, im Fitnessstudio, in der Currywurstbude oder am Strand, in diesem Wimmelbuch sind auf jeder seiten unzählige Menschen, Tiere und kleine Geschichten zu entdecken - und mittendrin Hazel Brugger und Thomas Spitzer. Für ihre Serie 'Deutschland Was Geht' besuchten die beiden Comedians kuriose Orte und Veranstaltungen im ganzen Land. Kinder werden dieses Wimmelbuch lieben und Fans Schauplätze und Details wiedererkennen.`,
    kategorie: "Geschenkbücher und Humor",
    "ISBN/GTIN": "978-3-257-01294-1",
    Produktart: "Buch",
    Einbandart: "Gebunden ",
    Verlag: "Diogenes",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "29.09.2021",
    Gewicht: "",
    ArtikelNr: "19638636",
    Genre: "Comic",
  },
  {
    titel: "Beste Bilder 12",
    autor: "Antje Haubner",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783830336129/COPL/Haubner-Antje/Beste-Bilder-12.jpg?sq=2",
    preis: "12,00",
    sprache: "Deutsch",
    seiten: "176 ",
    beschreibung: `Wir leben in verrückten Zeiten!
Corona hat die Welt auch 2021 fest im Griff. Impfen heißt das Zauberwort in diesem Spritzenjahr! Dem Superwahljahr, dem Jahr der verschobenen Olympischen Spiele, politische und Umwelt-Krisen und -Katastrophen inklusive.
In über 250 Cartoons und Karikaturen erklären uns die besten deutschsprachigen Cartoonisten satirisch und mit viel schwarzem Humor das Geschehen in Deutschland und der Welt.
Der ein oder andere großartige Blödelwitz hat sich garantiert auch eingeschmuggelt.
Damit Ihnen auch 2021 das Lachen nicht vergeht!
ZusammenfassungDER satirische Jahresrückblick
Der satirische Jahresrückblick mit den besten Cartoons des Jahres 2021`,
    kategorie: "Geschenkbücher und Humor",
    "ISBN/GTIN": "978-3-8303-3612-9",
    Produktart: "Buch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "Lappan Verlag",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "15.11.2021",
    Gewicht: "646 ",
    ArtikelNr: "19761334",
    Genre: "Comic",
  },
  {
    titel: "Was wir verschweigen",
    autor: "artu tuominen",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783785727614/COPL/Tuominen-Arttu/Was-wir-verschweigen.jpg?sq=29",
    preis: "16,00",
    sprache: "Deutsch",
    seiten: "416 ",
    beschreibung: `Freundschaft hat nichts mit Recht oder Schuld zu tun. Das wüssten Sie, wenn Sie auch nur einmal in Ihrem Leben jemanden gekannt hätten, dem Sie bedingungslos vertrauen konnten."
    Pori, Finnland. An einem stürmischen Herbsttag wird ein sturzbetrunkener Mann mit mehreren Messerstichen in einem Holzhaus ermordet. Ein typisch finnischer Mord - so der lakonische Kommentar der hinzugerufenen Kommissare. Der Fall scheint zunächst schnell gelöst: Im nahe gelegenen Wald wird noch am gleichen Abend ein verdächtiger Mann festgenommen.
    Doch für den Ermittler Jari Paloviita entpuppt sich der Mord als schwierigster Fall seines Lebens. Der Verdächtige war in der Jugend sein allerbester Freund. Und Jari Paloviita verdankt ihm sein Leben ...`,
    kategorie: "Krimis und Thriller",
    "ISBN/GTIN": "",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "Bastei Lübbe",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "26.11.2021",
    Gewicht: "",
    ArtikelNr: "20226341",
    Genre: "Krimi",
  },
  {
    titel: "Funkenmord",
    autor: "Volker Klüpfel",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783548064918/COPL/Kl%C3%BCpfel-Volker/Funkenmord.jpg?sq=6",
    preis: "12,99",
    sprache: "Deutsch",
    seiten: "496 ",
    beschreibung: `Kluftinger steht vor einem Rätsel: Wie um Himmels Willen funktioniert eine Waschmaschine? Wieso gibt es verschiedene Sorten Waschmittel? Und wie überlebt man eine Verkaufsparty für Küchenmaschinen bei Doktor Langhammer? Weil seine Frau Erika krank ist und zu Hause ausfällt, muss sich Kluftinger mit derartig ungewohnten Fragen herumschlagen.
    Die Aufgaben im Präsidium sind nicht weniger anspruchsvoll: Der Kommissar will nach über dreißig Jahren den grausamen Mord an einer Lehrerin aufklären. Die junge Frau wurde am Funkensonntag an einem Kreuz verbrannt. Doch das Team des Kommissars zeigt wenig Interesse an dem Fall. Nur die neue Kollegin Lucy Beer steht dem Kommissar mit ihren unkonventionellen Methoden zur seiten. Der letzte Brief des Mordopfers bringt die beiden auf eine heiße Spur.`,
    kategorie: "Krimis und Thriller",
    "ISBN/GTIN": "978-3-548-06491-8",
    Produktart: "Taschenbuch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "Ullstein TB",
    Genre: "Krimi",
  },
  {
    titel: "Der Geheimbund",
    autor: "Daniel Silva",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783749901593/COPL/Silva-Daniel/Der-Geheimbund.jpg?sq=12",
    preis: "16,00",
    sprache: "Deutsch",
    seiten: "448",
    beschreibung: `Der Papst ist tot! Gabriel Allon, legendärer Agent und inzwischen Direktor des israelischen Geheimdienstes, hält sich gerade in Venedig auf, als ihn die Nachricht erreicht. Kurze Zeit später kontaktiert ihn ein alter Freund, Luigi Donati, der Privatsekretär des verstorbenen Pontifex. Donati hegt Zweifel an der offiziellen Darstellung vom Herzinfarkt in der päpstlichen Privatkapelle. Grund dafür liefert der Umstand, dass der Schweizergardist, der in der Todesnacht Wache hielt, verschwunden ist - ebenso wie ein Brief unbekannten Inhalts, der vom Papst für Allon bestimmt war. Gabriel verspricht, seinem Freund zu helfen. Die Spuren führen ihn zu einem mysteriösen Orden von religiösen Hardlinern, der einen unheilvollen Bund mit Europas aufstrebender politischen Rechten eingegangen ist.`,
    kategorie: "Krimis und Thriller",
    "ISBN/GTIN": "978-3-7499-0159-3",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "HarperCollins Hamburg",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "26.10.2021",
    Gewicht: "",
    ArtikelNr: "19436331",
    Genre: "Krimi",
  },
  {
    titel: "Ostfriesensturm",
    autor: "Klaus Wolf",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783596700035/COPL/Wolf-Klaus-Peter/Ostfriesensturm.jpg?sq=4",
    preis: "13,00",
    sprache: "Deutsch",
    seiten: "560 ",
    beschreibung: `Der 16. Fall für Ostfrieslands Top-Ermittlerin Ann Kathrin Klaasen von Nummer-1-Bestsellerautor Klaus-Peter Wolf.
    Der Anruf erreicht Ann Kathrin Klaasen und Frank Weller beim Spaziergang am menschenleeren Strand. In einer Ferienwohnung auf Wangerooge wurde die Leiche eines Mannes gefunden. Die Tötungsart lässt vermuten, dass hierfür das organisierte Verbrechen verantwortlich ist - ein Verdacht, der Ann Kathrin und ihr Team sofort in höchste Alarmbereitschaft versetzt. In einem Tierpark geschieht kurz darauf ein weiterer Mord. Unter Hochdruck durchsucht die Polizei leer stehende Ferienwohnungen, nachdem alle Touristen Ostfriesland verlassen mussten. Wo versteckt sich der Killer?
    Für Ann Kathrin Klaasen und ihr Team beginnt eine Ermittlung unter noch nie dagewesenen Bedingungen.`,
    kategorie: "Krimis und Thriller",
    "ISBN/GTIN": "978-3-596-70003-5",
    Produktart: "Taschenbuch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "FISCHER Taschenbuch",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "09.02.2022",
    Gewicht: "487 ",
    ArtikelNr: "19765723",
    Genre: "Krimi",
  },
  {
    titel: "Geheime Quellen",
    autor: "Donna Leon",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783257246155/COPL/Leon-Donna/Geheime-Quellen.jpg?sq=1",
    preis: "13,00",
    sprache: "Deutsch",
    seiten: "320 ",
    beschreibung: `Als Vittorio Fadalto in einer Sommernacht auf dem Rückweg von der Arbeit mit dem Motorrad verunglückt, glauben alle an einen Unfall. Nur nicht seine Frau, die Brunetti um Hilfe bittet. Wollte tatsächlich jemand Fadalto etwas Böses? Oder sind das nur Hirngespinste seiner schwerkranken Frau? Brunetti braucht all seine Intuition - und enthüllt schließlich ein Verbrechen größeren Ausmaßes mit Folgen für die Gewässer des ganzen Veneto.`,
    kategorie: "Krimis und Thriller",
    "ISBN/GTIN": "978-3-257-24615-5",
    Produktart: "Taschenbuch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "Diogenes",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "27.10.2021",
    Gewicht: "",
    ArtikelNr: "19638737",
    Genre: "Krimi",
  },
  {
    titel: "Eines Menschen Flügel",
    autor: "Andreas Eschenbach",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783404209767/COPL/Eschbach-Andreas/Eines-Menschen-Fl%C3%BCgel.jpg?sq=24",
    preis: "14,90",
    sprache: "Deutsch",
    seiten: "1264",
    beschreibung: `Eine ferne Zukunft auf einem fernen, scheinbar paradiesischen Planeten - doch der Schein trügt. Etwas Mörderisches lauert unter der Erde. Daher haben die Siedler ihre Kinder gentechnisch aufgerüstet, sodass sie fliegen können. Es gibt jedoch weitere Rätsel: Noch nie haben die Menschen die Sterne gesehen. Der Himmel ist immer bedeckt, als würde sich dahinter etwas verbergen. Den Himmel, so heißt es, kann man nicht erreichen. Oder doch? Owen, einem Außenseitenr, gelingt es - mit tödlichen Folgen ...`,
    kategorie: "Fantasy & Sci-Fi",
    "ISBN/GTIN": "978-3-404-20976-7",
    Produktart: "Taschenbuch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "Bastei Lübbe",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "26.11.2021",
    Gewicht: "",
    ArtikelNr: "19686422",
    Genre: "Science-Fiction",
  },
  {
    titel: "Stalker",
    autor: "Arkadi Strugatzki",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783453321014/COPL/Strugatzki-Arkadi/Stalker.jpg?sq=2",
    preis: "12,99",
    sprache: "Deutsch",
    seiten: "400",
    beschreibung: `Das legendäre Meisterwerk jetzt neu übersetzt
    Red Shewhart ist ein Stalker, ein Glücksritter, der illegal immer wieder in die Sperrzone eindringt, in der einst die Aliens gelandet sind. Dort spürt er die Hinterlassenschaften der Außerirdischen auf, um sie auf dem Schwarzmarkt zu verkaufen. Niemand weiß, wie diese Artefakte funktionieren und wozu sie einmal gedient haben. Manche von ihnen bergen tödliche Gefahren, während andere die Unsterblichkeit versprechen. Red und sein Freund Kirill suchen nach einem ganz besonderen Gegenstand, der sie so reich machen wird, dass sich die Stalker nie wieder ins Sperrgebiet wagen müssen. Doch die Zone gibt ihre Geheimnisse nicht so einfach preis ...`,
    kategorie: "Fantasy & Sci-Fi",
    "ISBN/GTIN": "978-3-453-32101-4",
    Produktart: "Taschenbuch",
    Einbandart: "kartoniert, Paperback ",
    Verlag: "Heyne",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "13.12.2021",
    Gewicht: "528 ",
    ArtikelNr: "17504008",
    Genre: "Science-Fiction",
  },
  {
    titel: "Die Haarteppichknüpfer",
    autor: "Andreas Eschenbach",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783404209798/COPL/Eschbach-Andreas/Die-Haarteppichkn%C3%BCpfer.jpg?sq=18",
    preis: "12,90",
    sprache: "Deutsch",
    seiten: "320",
    beschreibung: `Schon seit jeher fertigen die Haarteppichknüpfer ihre Teppiche für den Kaiser - Teppiche, die aus den Haaren ihrer Frauen und Töchter bestehen. Für die Herstellung eines einzigen Teppichs benötigen die Knüpfer ihr ganzes Leben, und von dem Erlös kann eine Generation ihrer Familie leben. So war es seit Anbeginn der Zeit. Doch eines Tages taucht ein Raumschiff im Orbit der Welt auf, das kurz darauf landet, um dem Geheimnis der wundersamen Haarteppiche auf den Grund zu gehen - einem Geheimnis, das alle Vorstellungskraft übersteigt.`,
    kategorie: "Fantasy & Sci-Fi",
    "ISBN/GTIN": "978-3-404-20979-8",
    Produktart: "Taschenbuch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "Bastei Lübbe",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "26.11.2021",
    Gewicht: "",
    ArtikelNr: "19690063",
    Genre: "Science-Fiction",
  },
  {
    titel: "Der Gottkaiser des Wüstenplaneten",
    autor: "Frank Herbert",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783453320444/COPL/Herbert-Frank/Der-Gottkaiser-des-W%C3%BCstenplaneten.jpg?sq=2",
    preis: "14,99",
    sprache: "Deutsch",
    seiten: "560 ",
    beschreibung: `Dreieinhalb Jahrtausende sind auf Arrakis vergangen, und die Welt hat sich gewandelt: Der ehemalige Wüstenplanet ist dank technischer Mittel eine grüne Oase geworden. Die einst so stolzen Fremen sind nur noch ein Schatten ihrer selbst, eine Touristenattraktion. Doch es gibt noch ein Stück Vergangenheit auf Arrakis, sorgfältig vor Feuchtigkeit geschützt: die Wüste Sareer. Dort lebt Leto II., der Sohn von Paul Muad'dib. Seit Jahrtausenden vollzieht sein Körper eine Wandlung, geht eine Symbiose mit dem Shai-Hulud ein. Er hat seine Menschlichkeit aufgegeben, um die Menschen zu retten, tritt jetzt als Gott auf und verlangt absolute Unterwerfung. Doch seine Gegner wissen, dass er verletzlich ist - und sie verfügen über die Waffen, um ihn zu vernichten ...`,
    kategorie: "Fantasy & Sci-Fi",
    "ISBN/GTIN": "978-3-453-32044-4",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "Heyne",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "13.12.2021",
    Gewicht: "642 ",
    ArtikelNr: "1595066",
    Genre: "Science-Fiction",
  },
  {
    titel: "The Ministry for the Future",
    autor: "Kim Robinson",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9780356508863/COPL/Robinson-Kim-Stanley/The-Ministry-for-the-Future.jpg?sq=3",
    preis: "12,50",
    sprache: "Englisch",
    seiten: "592",
    beschreibung: `ONE OF BARACK OBAMA'S FAVOURITE READS OF THE YEAR
    'If I could get policymakers and citizens everywhere to read just one book this year, it would be Kim Stanley Robinson's The Ministry for the Future' Ezra Klein, Vox
    The Ministry for the Future is a masterpiece of the imagination, using fictional eyewitness accounts to tell the story of how climate change will affect us all. Its setting is not a desolate, postapocalyptic world, but a future that is almost upon us. Chosen by Barack Obama as one of his favorite books of the year, this extraordinary novel from visionary writer Kim Stanley Robinson will change the way you think about the climate crisis.
    'A novel that presents a rousing vision of how we might unite to overcome the greatest challenge of our time' TED.com
    'A breathtaking look at the challenges that face our planet in all their sprawling magnitude and also in their intimate, individual moments of humanity' Booklist (starred review)
    'Gutsy, humane . . . a must-read for anyone worried about the future of the planet' Publishers Weekly (starred review)
    'A sweeping epic about climate change and humanity's efforts to try and turn the tide before it's too late' Polygon (Best of the Year)`,
    kategorie: "Fantasy & Sci-Fi",
    "ISBN/GTIN": "978-0-356-50886-3",
    Produktart: "Taschenbuch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "Little",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "21.10.2021",
    Gewicht: "408 ",
    ArtikelNr: "19101228",
    Genre: "Science-Fiction",
  },
  {
    titel: "Die Hohenzollern und die Nazis",
    autor: "Stephan Malinowski",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783549100295/COPL/Malinowski-Stephan/Die-Hohenzollern-und-die-Nazis.jpg?sq=3",
    preis: "35,00",
    sprache: "Deutsch",
    seiten: "752",
    beschreibung: `"Stephan Malinowski [erzählt] für das große Publikum, wie Mitglieder der Monarchenfamilie zu Steigbügelhaltern Hitlers wurden." Lothar Müller, Süddeutsche Zeitung
    Seit über 100 Jahren haben die »Oberhäupter« der Hohenzollern immer wieder mit Juristen, Historikern, Journalisten, Ghostwritern und PR-Beratern zusammengearbeitet, mit deren Hilfe sie das Bild der Familie in der Öffentlichkeit aufpolierten. Nun werden Rollen und Selbstdarstellung der wichtigsten Familienmitglieder von einem der besten Kenner der Materie erstmals analysiert und dargestellt: In einer großen historischen Erzählung zieht Stephan Malinowski den Bogen über drei Generationen von 1918 bis in die Gegenwart und beschreibt das politische Milieu, in dem sich ihre Akteure bewegten.`,
    kategorie: "Sachbücher und Ratgeber",
    "ISBN/GTIN": "978-3-549-10029-5",
    Produktart: "Buch",
    Einbandart: " Gebunden",
    Verlag: "Propyläen",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "27.09.2021",
    Gewicht: "837 ",
    ArtikelNr: "20116662",
    Genre: "Sachbuch",
  },
  {
    titel: "Der Storyteller - Geschichten aus dem Leben und der Musik",
    autor: "D von Grohl",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783550202032/COPL/Grohl-D/Der-Storyteller---Geschichten-aus-dem-Leben-und-der-Musik.jpg?sq=3",
    preis: "22,99",
    sprache: "Deutsch",
    seiten: "464",
    beschreibung: `Drummer von Nirvana, Band Leader der Foo Fighters, erfolgreicher Solokünstler: Dave Grohl ist einer der größten Rockstars unserer Zeit - und seine Stories sind der lässigste Bestseller im Herbst 2021

    "Es gibt einen roten Faden, der sich durch alles zieht, was ich tue: das Geschichtenerzählen. Ob in Liedern, Filmen oder auf Instagram, ich habe immer das Bedürfnis, Momente aus meinem Leben zu teilen."
    Dave Grohl ist ein Weltstar auf den Musikbühnen. Und er ist ein fulminanter Erzähler. Von den Geschichten seines Lebens handelt sein Buch: von einschneidenden Erlebnissen in Kindheit und Jugend, vom Aufbruch aus der Familie in die Welt der Musik, von eindrücklichen Begegnungen, einem Auftritt im Weißen Haus oder auch einem partysprengenden Feuerwerk bei einer Familienfeier. Grohl schildert ein Leben in voller Lautstärke, das reich ist an lustigen Absurditäten wie auch berührenden Momenten.`,
    kategorie: "Sachbücher und Ratgeber",
    "ISBN/GTIN": "978-3-550-20203-2",
    Produktart: "Buch",
    Einbandart: "Gebunden ",
    Verlag: "Ullstein HC",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "01.11.2021",
    Gewicht: "573 ",
    ArtikelNr: "19811209",
    Genre: "Sachbuch",
  },
  {
    titel: "Immun",
    autor: "Phillip Dettner",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783864931758/COPL/Dettmer-Philipp/Immun.jpg?sq=6",
    preis: "19,99",
    sprache: "Deutsch",
    seiten: "432 ",
    beschreibung: `Das Immunsystem als Blockbuster: vom Macher des YouTube-Kanals »kurzgesagt«
    Philipp Dettmer, Gründer und Kopf von »kurzgesagt - in a nutshell«, einer der weltweit erfolgreichsten Wissenskanäle auf YouTube, erklärt unser Immunsystem anschaulich, unterhaltsam und witzig - passend in eine Zeit, in der viele genauer wissen möchten, wie die Immunabwehr unseres Körpers eigentlich funktioniert.
    In jeder Sekunde unseres Lebens werden wir angegriffen. Bakterien, Viren, Pilzsporen und andere Lebewesen wollen in unseren Körper eindringen, unsere Energie rauben und uns krank machen. Doch dann werden sie von einer riesigen Armee Zellen angegriffen, unserem Immunsystem. Die Zellen kämpfen wie ein T-Rex auf Speed und opfern ihr eigenes Leben für uns. Ohne Immunsystem würden wir innerhalb von Sekunden sterben. Das klingt simpel, ist aber in Wirklichkeit kompliziert, wunderschön und einfach erstaunlich.
    »Mit seinen großartigen Vergleichen und genialen Erklärungen für komplizierte Gedanken gibt Philipp Dettmer eine glänzende Einführung in das riesige System, mit dem unser Organismus gegen Infektionen und andere Bedrohungen kämpft.« - John Green, Autor des Bestsellers Das Schicksal ist ein mieser Verräter
    »Immun liest sich wie ein fesselnder Sciencefiction-Roman: Philipp Dettmer nimmt uns mit auf eine Reise in unseren eigenen Organismus. Dort begegnen wir den erfahrenen Kriegern, skrupellosen Gladiatoren und getarnten Detektiven, die uns im alltäglichen Krieg gegen Billionen erbarmungslose, feindliche Mikroorganismen beschützen. Seit ich das Buch gelesen habe, verstehe ich meinen Körper besser als je zuvor. Immun ist ein Leckerbissen für Neugierige.« - Tim Urban`,
    kategorie: "Sachbücher und Ratgeber",
    "ISBN/GTIN": "978-3-86493-175-8",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "Ullstein Extra",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "01.11.2021",
    Gewicht: "623",
    ArtikelNr: "19543543",
    Genre: "Sachbuch",
  },
  {
    titel: "Pfoten vom Tisch!",
    autor: "Hape Kerkeling",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783492080002/COPL/Kerkeling-Hape/Pfoten-vom-Tisch.jpg?sq=10",
    preis: "22,00",
    sprache: "Deutsch",
    seiten: "304",
    beschreibung: `Lustig, persönlich und lehrreich: Hapes Samtpfoten-Atlas ist das ultimative Katzenbuch für alle Tierliebhaber!
    Mit seiner wundervollen Liebeserklärung an die Mieze etabliert sich Bestseller-Autor Hape Kerkeling nun als persönlicher Ratgeber für Katzenliebhaber.
    Ob er mal weg ist, an die frische Luft muss oder einfach auf sein Leben blickt: Hape Kerkeling ist ein Meister der vielschichtigen Autobiografie, in der es nie nur um seinen Lebensweg geht. Wenn er über sich erzählt, können seine Millionen Leserinnen und Leser immer etwas lernen - selbst wenn sie das gar nicht vorhatten.
    Darum ist "Pfoten vom Tisch!: Meine Katzen, andere Katzen und ich" mehr als eine Hommage an seine lebenslange Katzenliebe. Der SPIEGEL-Bestseller gilt bereits jetzt als der amüsanteste Ratgeber für neue und alte Katzenfans!
    In schönster Tradition von "Ich bin dann mal weg" und "Der Junge muss an die frische Luft" zoomt Kerkeling nah an seine persönlichen Erfahrungen heran und vermittelt im gewohnt leichtfüßig-selbstironischen Stil tiefgründiges Wissen über die richtigen Katzennamen, den Umgang mit Katzenkrankheiten oder die Frage, warum Katzen schnurren.
    Der Nummer 1-Hit der SPIEGEL Bestsellerliste - das Lesevergnügen mit Miau-Faktor!
    Selbst Leser mit Katzenallergie werden diese kurzweilige Lektüre verschlingen. Hape Kerkeling ist Deutschlands vielseitigster Entertainer und ein Bestseller-Autor, den die Leserinnen und Leser lieben. Das hat er bereits in Millionen verkauften Exemplaren unter Beweis gestellt .
    Der ultimative Geschenktipp für Katzeneltern!
    Das Leben mit Miez ist nicht immer einfach. Doch Hauptsache, Sie können darüber lachen! "Pfoten vom Tisch!" gehört zur Grundausstattung für alle, die ihr Zuhause erstmals mit einem Kätzchen teilen - und damit die Herrschaft an ihre Katze abgeben. Auch langjährige Untertanen ihrer Samtpfote lernen sich und ihren Vierbeiner noch einmal völlig neu kennen.`,
    kategorie: "Sachbücher und Ratgeber",
    "ISBN/GTIN": "978-3-492-08000-2",
    Produktart: "Buch",
    Einbandart: " Gebunden",
    Verlag: "Piper",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "30.06.2021",
    Gewicht: "427 ",
    ArtikelNr: "19564491",
    Genre: "Sachbuch",
  },
  {
    titel: "Sapiens",
    autor: "Harari Juvai",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783406777516/COPL/Harari-Yuval-Noah/Sapiens.jpg?sq=22",
    preis: "25,00",
    sprache: "Deutsch",
    seiten: "256",
    beschreibung: `SAPIENS - DIE GESCHICHTE GEHT WEITER
    "Sapiens" kehrt zurück: Die Graphic Novel zu Yuval Noah Hararis Weltbestseller "Eine kurze Geschichte der Menschheit" geht nach dem großen Erfolg des Pilots in die zweite Staffel. Im ersten Band schwangen sich die frühen Sapiens zu Herren der Welt auf. Im zweiten Band werden sie von einem völlig unscheinbaren Lebewesen aufs Kreuz gelegt. Wer das war? Das erfahren Sie in "Sapiens: Die Falle".
    Vor etwas mehr als 10.000 Jahren trafen einige Sapiens eine Entscheidung, die den Gang der Geschichte dramatisch verändern sollte: Sie fingen an, mit Weizen zu experimentieren. Bald war die Welt nicht mehr von einer relativ kleinen Zahl gesunder, gleicher und freier Jäger und Sammler bevölkert, sondern von einer sehr viel größeren Zahl hart arbeitender, schlecht ernährter und kranker Bauern. Die landwirtschaftliche Revolution legte die Grundlage für komplexere soziale und politische Gebilde. Königreiche und Imperien entstanden. Doch für die meisten Menschen wurde das Leben schlechter. Sie waren jetzt Sklaven des Weizens und mussten auf den Feldern Arbeiten verrichten, für die ihr Körper nicht gemacht war. Gleichzeitig kam die Ungleichheit in die Welt. Ohne die landwirtschaftliche Revolution gäbe es unseren heutigen Wohlstand nicht, aber er wurde möglich auf dem Rücken von Generationen unglücklicher Bauern.
    Die Sapiens sind zurück!
    Teil 2: Wie die Ungleichheit in die Welt kam
    Die landwirtschaftliche Revolution und ihre Folgen`,
    kategorie: "Sachbücher und Ratgeber",
    "ISBN/GTIN": "978-3-406-77751-6",
    Produktart: "Buch",
    Einbandart: " Gebunden",
    Verlag: "Beck",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "20.10.2021",
    Gewicht: "1170 ",
    ArtikelNr: "16414567",
    Genre: "Sachbuch",
  },
  {
    titel: "The Girls I've Been",
    autor: "Tess Sharpe",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783551584472/COPL/Sharpe-Tess/The-Girls-Ive-Been.jpg?sq=4",
    preis: "16,00",
    sprache: "Deutsch",
    seiten: "384 ",
    beschreibung: `Kuriose Unterhaltung für Fans von »One of Us Is Lying« - demnächst auch als Netflix-Film mit Millie Bobby Brown (»Stranger Things«)
    Meine Hände schwitzen. Ich kralle die Finger zusammen - Gott, wie lang geht das jetzt? Zwei Minuten? Fünf? Die Zeit verhält sich seltsam, wenn du auf dem Boden liegst und ein Typ mit einer Knarre vor deinem Gesicht herumfuchtelt.
    Rebecca, Samantha, Haley, Katie, Ashley - Nora musste schon viele Mädchen sein. Denn sie ist die Tochter einer Trickbetrügerin, die mit ihrer Hilfe kriminelle Saubermänner ausnimmt. Mit zwölf gelingt Nora die Flucht aus diesem Leben. Doch fünf »normale« Jahre später holt die Vergangenheit sie ein, als sie mit ihren besten Freunden Wes (ihr Ex) und Iris (ihre neue Liebe) in einen Banküberfall gerät. Die brutalen Gangster erwarten keinen Widerstand. Nichts hat sie auf Nora vorbereitet - oder auf die Tricks, die sie und ihre Alter Egos auf Lager haben. Ein raffiniertes Katz-und-Maus-Spiel beginnt.
    Diese Story hat viele Facetten: ein hochspannender Thriller zum Mitfiebern. Eine atemlose Escape-Story, die ständig Haken schlägt. Und ein vielschichtiger Coming-of-Age-Roman mit einer faszinierenden, coolen Protagonistin.
    »Ein fesselnder, explosiver und überzeugender Thriller.«
    Kirkus Reviews, Sternchenrezension
    ZusammenfassungDu glaubst, du kennst mich? Falsch gedacht.`,
    kategorie: "Kinderbücher",
    "ISBN/GTIN": "978-3-551-58447-2",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "Carlsen",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "21.10.2021",
    Gewicht: "522 ",
    ArtikelNr: "19760742",
    Genre: "Kinderbuch",
  },
  {
    titel: "Mein Lotta-Leben (18). Im Zeichen des Tapirs",
    autor: "Alice Panthermüller",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783401605050/COPL/Panterm%C3%BCller-Alice/Mein-Lotta-Leben-18.-Im-Zeichen-des-Tapirs.jpg?sq=4",
    preis: "12,00",
    sprache: "Deutsch",
    seiten: "160 ",
    beschreibung: `Frischer Lesestoff für alle "Mein Lotta-Leben"-Fans: Ein brandneuer Band zum Verschlingen und Schlapplachen
    In Lottas Klasse steht nach den Herbstferien "Astronomie" auf dem Stundenplan. Während Paul vor lauter Begeisterung schon eine Geburtstagsfeier in der Sternwarte plant, ist Lotta eher skeptisch. Auch weil Cheyenne "Astronomie" mit "Astrologie" verwechselt und sich jetzt ständig mit Horoskopen beschäftigt. Was aber noch schlimmer ist: Lottas beste Freundin muss in den Herbstferien mit ihrer Familie in den Harz reisen. Und Paul und Rémi sind nur noch mit ihrem großen Astronomie-Projekt beschäftigt. Dabei braucht Lotta doch Hilfe dabei, herauszufinden, woher nachts die komischen Geräusche kommen ... Ist ihr etwa ein Alien auf der Spur?
    Von allen Fans ersehnt: Der neue Band der internationalen Kult-Bestsellerreihe von Alice Pantermüller und Daniela Kohl für Kinder ab 9. In gewohnter Gestaltung der "Mein Lotta-Leben"-Reihe: Mit hohem Illustrationsanteil zum Selbstlesen auch für weniger geübte Leser geeignet - garantiert ein Erfolgserlebnis.`,
    kategorie: "Kinderbücher",
    "ISBN/GTIN": "978-3-401-60505-0",
    Produktart: "Buch",
    Einbandart: " Gebunden",
    Verlag: "Arena",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "11.11.2021",
    Gewicht: "293 ",
    ArtikelNr: "19538775",
    Genre: "Kinderbuch",
  },
  {
    titel: "Guinness World Records 2022",
    autor: "Birgit Avoord",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783473480241/COPL/Guinness-World-Records-Ltd./Guinness-World-Records-2022.jpg?sq=2",
    preis: "22,00",
    sprache: "Deutsch",
    seiten: "256",
    beschreibung: `Der Bestseller unter den Rekord-Büchern ist zurück: Guinness World Records 2022 fasziniert mit den besten neuen Rekorden und den beliebtesten Rekord-Klassikern. Tolle Leistungen, meisterhaftes Können und Spaßrekorde - den Ideen und Themen in der deutschen Ausgabe des Guinness-Buchs der Rekorde sind keine Grenzen gesetzt. Verrückte Einfälle, unglaubliche Fakten und spektakuläres Fotomaterial bringen Kinder und Erwachsene zum Staunen, Schaudern, Gruseln und Lachen. Egal ob zu Weihnachten, zum Geburtstag oder zu Ostern - das Geschenk mit garantiertem Wow-Effekt!`,
    kategorie: "Kinderbücher",
    "ISBN/GTIN": "978-3-473-48024-1",
    Produktart: "Buch",
    Einbandart: " Gebunden",
    Verlag: "Ravensburger Verlag",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "16.09.2021",
    Gewicht: "1160 ",
    ArtikelNr: "19510259",
    Genre: "Kinderbuch",
  },
  {
    titel: "Die Schule der magischen Tiere 12: Voll das Chaos!",
    autor: "Margit Auer",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783551653628/COPL/Auer-Margit/Die-Schule-der-magischen-Tiere-12-Voll-das-Chaos.jpg?sq=6",
    preis: "12,00",
    sprache: "Deutsch",
    seiten: "12,00",
    beschreibung: `Jetzt kostenlos herunterladen - die App zur Serie!
    Wer wird dieses Mal ein magisches, sprechendes Tier erhalten?
    Ist die magische Zoohandlung in Gefahr? Eine Möwe überbringt Mr. Morrison eine mysteriöse Einladung. Mortimer packt sofort seine Sachen und reist ab. Mit dabei: Pinkie, Mary Cornfield - und, gut versteckt, ein paar Kinder mit ihren magischen Tieren. Zur gleichen Zeit bricht in der Turmgasse das Chaos aus: Nicht nur die Erdmännchen tanzen auf dem Tisch ... "Oje, oje, oje", schimpft Eule Muriel.
    Die Kinder und ihre magischen Freunde helfen, wo sie können. Dabei machen sie eine verblüffende Entdeckung: Die magische Welt ist sehr viel größer, als sie bisher geglaubt haben!
    DIE SCHULE DER MAGISCHEN TIERE: Diese Schule birgt ein Geheimnis! Wer Glück hat, findet hier den besten Freund, den es auf der Welt gibt. Ein magisches Tier. Ein Tier, das sprechen kann. Wenn es zu dir gehört ...
    `,
    kategorie: "Kinderbücher",
    "ISBN/GTIN": "978-3-551-65362-8",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Carlsen",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "21.10.2021",
    Gewicht: "483 ",
    ArtikelNr: "19760929",
    Genre: "Kinderbuch",
  },
  {
    titel: "Die Duftapotheke (6). Das Vermächtnis der Villa Evie",
    autor: "Claudia Carls",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783401605982/COPL/Ruhe-Anna/Die-Duftapotheke-6.-Das-Verm%C3%A4chtnis-der-Villa-Evie.jpg?sq=6",
    preis: "15,00",
    sprache: "Deutsch",
    seiten: "328 ",
    beschreibung: `Die magischen Düfte sind in Gefahr - und nur Luzie kann sie retten!
    Auf Luzie Alvenstein und ihre Freunde warten dunkle Zeiten: Ihr Widersacher Edgar de Richemont versucht mit allen Mitteln, in die Villa Evie einzudringen. Denn nur mit der Duftapotheke kann er seinen Plan umsetzen und das Sentifleurs-Talent auf der ganzen Welt auslöschen. Nun ist es an Luzie und Mats, ihr Zuhause und die magischen Düfte zu schützen. Dabei stoßen sie auf verborgene Gänge und Räume, die scheinbar aus dem Nichts auftauchen und dabei immer mehr Geheimnisse offenbaren. Luzie spürt, tief im Herzen, dass die Villa Evie ihr helfen will. Doch Edgar ist gefährlicher als je zuvor - und er scheint zu allem bereit, um die Duftapotheke für sich zu gewinnen ...
    Große Spannung, Magie und Abenteuer für alle Mädchen und Jungs ab 10 Jahren. Fantasievoll erzählt von Erfolgsautorin Anna Ruhe und mit atmosphärischen, detailverliebten Schwarz-weiß-Illustrationen von Claudia Carls ("Woodwalkers", "Alea Aquarius").`,
    kategorie: "Kinderbücher",
    "ISBN/GTIN": "978-3-401-60598-2",
    Produktart: "Buch",
    Einbandart: " Gebunden",
    Verlag: "Arena",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "14.10.2021",
    Gewicht: "604 ",
    ArtikelNr: "19538619",
    Genre: "Kinderbuch",
  },
  {
    titel: "Elisa Hemmiltons Kofferkrimi",
    autor: "Lin Rina",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783959913973/COPL/Rina-Lin/Elisa-Hemmiltons-Kofferkrimi.jpg?sq=1",
    preis: "16,90",
    sprache: "Deutsch",
    seiten: "425 ",
    beschreibung: `Ein Roman aus dem Staubchronik-Universum Alles begann mit dem äußerst unwahrscheinlichen Ereignis, dass ein Koffer vom Himmel fiel. London 1890/91 Die Metropolitan Police hat uns gebeten einen Bericht über die kürzlichen Ereignisse im Fall 'David Brighton' zu schreiben. Und wie wir - eine vorlaute Studentin und ein schusseliger Mechaniker - es geschafft haben, der ganzen Sache auf die Spur zu kommen, während die Polizei Däumchen gedreht hat. Da Jamie sich aber strikt weigert, zu Papier zu bringen, was wir durchlebt haben, bleibt diese Aufgabe an mir hängen: Elisa Hemmilton, mutige Laien-Ermittlerin, neugierige Spürnase und Siegerin der Herzen[1]. __________________________________[1] Trägst du nicht etwas zu dick auf, Liz? Wenn dir nicht passt, was ich hier fabriziere, dann hättest du es selber schreiben sollen, mein lieber Jamie.`,
    kategorie: "Jugendbücher",
    "ISBN/GTIN": "978-3-95991-397-3",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Drachenmond Verlag",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "16.11.2021",
    Gewicht: "503",
    ArtikelNr: "20142523",
    Genre: "Jugendbuch",
  },
  {
    titel:
      "Game Changer - Es gibt unendlich viele Möglichkeiten, alles falsch zu machen",
    autor: "Neal Shusterman",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783737358842/COPL/Shusterman-Neal/Game-Changer---Es-gibt-unendlich-viele-M%C3%B6glichkeiten-alles-falsch-zu-machen.jpg?sq=7",
    preis: "16,90",
    sprache: "Deutsch",
    seiten: "416",
    beschreibung: `Stell Dir vor, du könntest die Welt verändern ... Welche Entscheidung triffst Du?
    Ash ist ein weißer, heterosexueller cis-Junge aus der Mittelschicht. Er hält sich selbst für einen guten Kerl, aber nicht gerade für den Mittelpunkt des Universums. Bis er eines Freitags in eine andere Dimension katapultiert wird, in der er genau das ist - der Mittelpunkt des Universums! Damit verfügt ausgerechnet Ash nun über die Macht, die Welt zu verändern. Doch irgendetwas geht schief, und Ash führt - aus Versehen - die Rassentrennung wieder ein. Natürlich will er das wieder geradebiegen, aber: Es gibt unendlich viele Möglichkeiten, alles falsch zu machen.
    Ein Social Thriller der Extraklasse über eine durch und durch ungerechte Welt wie unsere.`,
    kategorie: "Jugendbücher",
    "ISBN/GTIN": "978-3-7373-5884-2",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "FISCHER Sauerländer",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "13.10.2021",
    Gewicht: "662",
    ArtikelNr: "19766148",
    Genre: "Jugendbuch",
  },
  {
    titel: "Krabat: Roman",
    autor: "Otfried Preusler",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783522202275/COPL/Preu%C3%9Fler-Otfried/Krabat-Roman.jpg?sq=4",
    preis: "8,95",
    sprache: "Deutsch",
    seiten: "272 ",
    beschreibung: `Die seitenzählung ist mit den bisher erschienenen Schulausgaben identisch.
    Neugier lockt Krabat zur Mühle am Koselbruch, vor der alle warnen, weil es dort nicht ganz geheuer sei. Ein leichtes und schönes Leben wird Krabat hier versprochen. Doch der Preis dafür ist hoch. Und aus der Verstrickung mit dem Bösen kann ihn nur die bedingungslose Liebe eines Mädchens retten.
    Meisterhaft erzählt, unheimlich, spannend, sein bestes Buch: So äußern sich Presse und Leser über Krabat von Otfried Preußler, der Geschichte vom magischen Spiel um die Freiheit des Menschen. Da verwundert es nicht, dass dieses Werk mit vielen bedeutenden Preisen ausgezeichnet wurde und noch heute zu den Büchern gehört, die lange nachklingen, egal wie alt man ist.`,
    kategorie: "Jugendbücher",
    "ISBN/GTIN": "978-3-522-20227-5",
    Produktart: "Buch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "Thienemann in der Thienemann-Esslinger Verlag GmbH",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "15.07.2021",
    Gewicht: "438 ",
    ArtikelNr: "1765090",
    Genre: "Jugendbuch",
  },
  {
    titel: "Off the Record. Unsere Worte sind unsere Macht",
    autor: "Camryn Carret",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783401606453/COPL/Garrett-Camryn/Off-the-Record.-Unsere-Worte-sind-unsere-Macht.jpg?sq=5",
    preis: "15,00",
    sprache: "Deutsch",
    seiten: "416",
    beschreibung: `Schweigen bedeutet Unrecht.
    Reden bedeutet die Gefahr, alles zu verlieren.
    Für was würdest du dich entscheiden?
    Schreiben ist Josies Leben. In Texten kann sie ihre Gedanken fliegen lassen und ihr inneres Sorgenkarussell anhalten. Als die 17-Jährige einen Schreibwettbewerb gewinnt, darf sie ein Filmteam auf eine Pressetour durch die USA begleiten. Doch auf der Reise erfährt Josie etwas Ungeheuerliches: Ein gefeierter Regisseur belästigt Mädchen und Frauen am Set - und kommt offenbar schon lange damit durch. Schnell wird die ersehnte Reise zu ihrer größten Herausforderung, denn was kann ein Mädchen wie sie schon ausrichten? Es gibt so viele Gründe, zu schweigen. Es gibt so viele Gründe, nichts zu sagen. Und doch muss Josie den Mut finden, den Text zu schreiben, der alles verändern wird.
    In "Off the Record" gibt Camryn Garrett all den mutigen und kämpferischen Menschen ein Gesicht, die sich für Gerechtigkeit einsetzen und deren Geschichten doch zu oft unsichtbar bleiben.
    "Selten habe ich einen Menschen, der sich selbst als ängstlich bezeichnet, so für seinen Mut bewundert, wie Josie Wright. Ihre Story macht Mut. Sie geht uns alle an - und dieser Roman ist ganz großes Kino." (Isabel Abedi)`,
    kategorie: "Jugendbücher",
    "ISBN/GTIN": "978-3-401-60645-3",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "Arena",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "14.10.2021",
    Gewicht: "621",
    ArtikelNr: "19538709",
    Genre: "Jugendbuch",
  },
  {
    titel: "Gregs Tagebuch 16 - Volltreffer!",
    autor: "Jeff Kiney",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783833906800/COPL/Kinney-Jeff/Gregs-Tagebuch-16---Volltreffer.jpg?sq=20",
    preis: "14,99",
    sprache: "Deutsch",
    seiten: "224 ",
    beschreibung: `Greg Heffley und Sport? Das passt einfach nicht zusammen. Nach einem fürchterlichen Trainingstag in der Schule erklärt Greg seine Sportkarriere für offiziell beendet. Doch leider hat Greg die Rechnung ohne seine Mom gemacht. Sie überredet ihn, der Sache eine letzte Chance zu geben und sich für eins der Basketballteams zu bewerben.
    Wie zu erwarten, sind die Auswahlspiele ein Reinfall, und Greg ist sich sicher, dass er es mal wieder versemmelt hat. Doch dann schafft er es tatsächlich ins Team, wenn auch nur in das schlechteste der ganzen Schule. Die Saison beginnt, und die Chancen, auch nur ein Spiel zu gewinnen, sind gleich null. Aber im Sport ist alles möglich, oder? Und so bekommt Greg im entscheidenden Moment im Spiel den Ball ... Wird er über sich hinauswachsen und einen Treffer landen? Oder wird er es mal wieder vermasseln?
    Gregs Tagebuch von Jeff Kinney ist eine der erfolgreichsten Kinderbuchserien der Welt. Die humorvollen Comics um Greg Heffley besitzen mittlerweile Kultstatus.`,
    kategorie: "Jugendbücher",
    "ISBN/GTIN": "978-3-8339-0680-0",
    Produktart: "Buch",
    Einbandart: "Gebunden ",
    Verlag: "Baumhaus Medien",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "13.11.2021",
    Gewicht: "",
    ArtikelNr: "19686672",
    Genre: "Jugendbuch",
  },
  {
    titel: "Lustiges Taschenbuch Weihnachten 27",
    autor: "Disney",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783841328274/COPL/Disney/Lustiges-Taschenbuch-Weihnachten-27.jpg?sq=3",
    preis: "8,50",
    sprache: "Deutsch",
    seiten: "256 ",
    beschreibung: `Der Duft von frisch gebackenen Plätzchen und grünen Tannenzweigen verrät es: Es weihnachtet in Entenhausen. Die Stadt hat sich herausgeputzt und strahlt im Lichterglanz! Und die Leute strahlen vor Vorfreude auf das Fest! Alle sind glücklich! Wirklich alle? Nein! Einer bläst Trübsal so kurz vor Heiligabend. Elbin der Elf hat lange für den Weihnachtsmann gearbeitet. Nun aber nicht mehr. Er sah sich gezwungen, die wundertätige Werkstatt am Nordpol für immer zu verlassen. Doch Tick, Trick und Track finden, niemand sollte so traurig sein müssen, erst recht nicht an Weihnachten. Können sie Elbin helfen?`,
    kategorie: "Geschenkbücher und Humor",
    "ISBN/GTIN": "978-3-8413-2827-4",
    Produktart: "Taschenbuch",
    Einbandart: "Kartoniert, Paperback ",
    Verlag: "Egmont Ehapa Berlin Buch",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "02.11.2021",
    Gewicht: "",
    ArtikelNr: "19574618",
    Genre: "Comic",
  },
  {
    titel: "Muttis Rückkehr",
    autor: "Heiko Sakurai",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783946972556/COPL/Sakurai-Heiko/Muttis-R%C3%BCckkehr.jpg?sq=1",
    preis: "19,90",
    sprache: "Deutsch",
    seiten: "176",
    beschreibung: `Die besten Cartoons von Heiko Sakurai fassen das Jahr 2021 satirisch zusammen. Meisterhaft tiefsinnig und traumhaft komisch!`,
    kategorie: "Geschenkbücher und Humor",
    "ISBN/GTIN": "978-3-946972-55-6",
    Produktart: "Buch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "Schaltzeit",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "02.12.2021",
    Gewicht: "500 ",
    ArtikelNr: "19979780",
    Genre: "Comic",
  },
  {
    titel: "Deutschland Was Geht",
    autor: "Hazel Brugger",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783257012941/COPL/Brugger-Hazel/Deutschland-Was-Geht.jpg?sq=7",
    preis: "14,00",
    sprache: "Deutsch",
    seiten: "16 ",
    beschreibung: `Ob auf der Straußenfarm, im Fitnessstudio, in der Currywurstbude oder am Strand, in diesem Wimmelbuch sind auf jeder seiten unzählige Menschen, Tiere und kleine Geschichten zu entdecken - und mittendrin Hazel Brugger und Thomas Spitzer. Für ihre Serie 'Deutschland Was Geht' besuchten die beiden Comedians kuriose Orte und Veranstaltungen im ganzen Land. Kinder werden dieses Wimmelbuch lieben und Fans Schauplätze und Details wiedererkennen.`,
    kategorie: "Geschenkbücher und Humor",
    "ISBN/GTIN": "978-3-257-01294-1",
    Produktart: "Buch",
    Einbandart: "Gebunden ",
    Verlag: "Diogenes",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "29.09.2021",
    Gewicht: "",
    ArtikelNr: "19638636",
    Genre: "Comic",
    menge:4
  },
  {
    titel: "Beste Bilder 12",
    autor: "Antje Haubner",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783830336129/COPL/Haubner-Antje/Beste-Bilder-12.jpg?sq=2",
    preis: "12,00",
    sprache: "Deutsch",
    seiten: "176 ",
    beschreibung: `Wir leben in verrückten Zeiten!
    Corona hat die Welt auch 2021 fest im Griff. Impfen heißt das Zauberwort in diesem Spritzenjahr! Dem Superwahljahr, dem Jahr der verschobenen Olympischen Spiele, politische und Umwelt-Krisen und -Katastrophen inklusive.
    In über 250 Cartoons und Karikaturen erklären uns die besten deutschsprachigen Cartoonisten satirisch und mit viel schwarzem Humor das Geschehen in Deutschland und der Welt.
    Der ein oder andere großartige Blödelwitz hat sich garantiert auch eingeschmuggelt.
    Damit Ihnen auch 2021 das Lachen nicht vergeht!
    ZusammenfassungDER satirische Jahresrückblick
    Der satirische Jahresrückblick mit den besten Cartoons des Jahres 2021`,
    kategorie: "Geschenkbücher und Humor",
    "ISBN/GTIN": "978-3-8303-3612-9",
    Produktart: "Buch",
    Einbandart: " Kartoniert, Paperback",
    Verlag: "Lappan Verlag",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "15.11.2021",
    Gewicht: "646 ",
    ArtikelNr: "19761334",
    Genre: "Comic",
    menge:2
  },
  {
    titel: "Das verlorene Paradies",
    autor: "Abdulrazak, Gurnah",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783328602583/COPL/Gurnah-Abdulrazak/Das-verlorene-Paradies.jpg?sq=7",
    preis: "25,00",
    sprache: "Deutsch",
    seiten: "336",
    beschreibung: `Ostafrika, Ende des 19. Jahrhunderts: Der zwölfjährige Yusuf führt mit seiner
    Familie ein einfaches Leben auf dem Land. Als der Vater sich mit seinem
    kleinen Hotel verschuldet, wird Yusuf in die Hände von Onkel Aziz gegeben und
    landet im lebhaften Treiben der Stadt, zwischen afrikanischen Muslimen,
    christlichen Missionaren und indischen Geldverleihern. Die Gemeinschaft
    dieser Menschen ist alles andere als selbstverständlich und von subtilen
    Hierarchien bestimmt. Yusuf hilft in Aziz Laden und bei der Pflege seines
    paradiesisch anmutenden Gartens. Doch als der Kaufmann ihn auf eine
    Karawanenreise ins Landesinnere mitnimmt, endet Yusufs Jugend abrupt. Die
    gefährliche Unternehmung bringt Krankheit und Tod und zeigt allen Teilnehmern
    schmerzhaft, dass die traditionelle Art des Handels keine Zukunft mehr hat.
    Was Yusuf erlebt, lässt ihn erwachsen werden. So verliebt sich der junge Mann
    nach seiner Heimkehr kopfüber, aber er und alle um ihn herum werden brutal
    mit der neuen Realität der deutschen Kolonialherrschaft konfrontiert.
    Einfühlsam, lebendig und in leichtem, humorvollem Ton, erzählt Abdulrazak
    Gurnah in »Das verlorene Paradies« vom Erwachsenwerden in Zeiten des
    kolonialen Umbruchs. Im Original 1994 erschienen, stand der Roman u.a. auf
    der Shortlist des Booker Prize und stellte für Gurnah den Durchbruch als
    Schriftsteller dar. Jetzt ist er endlich wieder in der Übersetzung von Inge
    Leipold auf Deutsch zu lesen.`,
    kategorie: "Neu und Bestseller",
    "ISBN/GTIN": "978-3-328-60258-3",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Penguin Verlag München",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "08.12.2021",
    Gewicht: "545 g",
    ArtikelNr: "16430532",
    Genre: "Belletristik",
    menge:20
  },
  {
    titel: "Vernichten",
    autor: "Michel, Houellebecq",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783832181932/COPL/Houellebecq-Michel/Vernichten.jpg?sq=2",
    preis: "28,00",
    sprache: "Deutsch",
    seiten: "624",
    beschreibung: `Kurz vor den französischen Präsidentschaftswahlen 2027 taucht im Netz ein Video auf, das die Hinrichtung des möglichen Kandidaten Bruno Juge zu zeigen scheint. Paul Raison ist Absolvent einer Elitehochschule und arbeitet als Spitzenbeamter im Wirtschaftsministerium. Als Mitarbeiter und Vertrautem Juges fällt ihm die Aufgabe zu, die Urheber des Videos ausfindig zu machen. Im Laufe seiner Nachforschungen kommt es zu einer Serie mysteriöser terroristischer Anschläge, zwischen denen kein Zusammenhang zu erkennen ist. Aber nicht nur die Arbeit, auch das Privatleben von Paul Raison ist alles andere als einfach. Er und seine Frau Prudence leben zwar noch zusammen, aber sie teilen nichts mehr miteinander. Selbst die Fächer im Kühlschrank sind getrennt. Während Juge um seine Kandidatur kämpft, kann Paul entscheidende Hinweise für die Aufklärung der Anschläge liefern. Doch letztlich verliert Juge gegen einen volksnahen ehemaligen Fernsehmoderator, und die Erkenntnisse aus Pauls Recherche sind nicht minder niederschmetternd für die Politik des Landes. Als Paul von seiner Arbeit freigestellt wird, kommt es zu einer Annäherung zwischen ihm und seiner Frau und die beiden finden wieder zueinander. Ein unerwartetes, wenn auch fragiles Glück ... Die Möglichkeiten und Unmöglichkeiten der Liebe, das komplexe Zusammenspiel von Gesellschaft und Politik und die weitreichende, oftmals kaum wahrnehmbare Verknüpfung von Politischem und Privatem - das sind die Themen des neuen Romans von Michel Houellebecq, dem großen Visionär der französischen Literatur.`,
    kategorie: "Neu und Bestseller",
    "ISBN/GTIN": "978-3-8321-8193-2",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "DuMont Buchverlag",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "11.01.2022",
    ArtikelNr: "16431062",
    Genre: "Belletristik",
    menge:16
  },
  {
    titel: "Zum Paradies",
    autor: "Hanya, Yanagihara",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783546100519/COPL/Yanagihara-Hanya/Zum-Paradies.jpg?sq=5",
    preis: "24,99",
    sprache: "Deutsch",
    seiten: "896",
    beschreibung: `»Tiefgründig, sensibel, spannend und ausreichend lang für meinen Geschmack.« Juli Zeh, Börsenblatt
    Drei Jahrhunderte, drei Versionen des amerikanischen Experiments: In ihrem kühnen neuen Roman - dem ersten seit Ein wenig Leben - erzählt Hanya Yanagihara von Liebenden, von Familie, vom Verlust und den trügerischen Versprechen gesellschaftlicher Utopien.
    1893, in einem Amerika, das anders ist, als wir es aus den Geschichtsbüchern kennen: New York gehört zu den Free States, in denen die Menschen so leben und so lieben, wie sie es möchten - so jedenfalls scheint es. Ein junger Mann, Spross einer der angesehensten und wohlhabendsten Familien, entzieht sich der Verlobung mit einem standesgemäßen Verehrer und folgt einem charmanten, mittellosen Musiklehrer.
    1993, in einem Manhattan im Bann der AIDS-Epidemie: Ein junger Hawaiianer teilt sein Leben mit einem deutlich älteren, reichen Mann, doch er verschweigt ihm die Erschütterungen seiner Kindheit und das Schicksal seines Vaters.
    2093, in einer von Seuchen zerrissenen, autoritär kontrollierten Welt: Die durch eine Medikation versehrte Enkelin eines mächtigen Wissenschaftlers versucht ohne ihn ihr Leben zu bewältigen - und herauszufinden, wohin ihr Ehemann regelmäßig an einem Abend in jeder Woche verschwindet.
    Drei Teile, die sich zu einer aufwühlenden, einzigartigen Symphonie verbinden, deren Themen und Motive wiederkehren, nachhallen, einander vertiefen und verdeutlichen: Ein Town House am Washington Square. Krankheiten, Therapien und deren Kosten. Reichtum und Elend. Schwache und starke Menschen. Die gefährliche Selbstgerechtigkeit von Mächtigen und von Revolutionären. Die Sehnsucht nach dem irdischen Paradies - und die Erkenntnis, dass es nicht existiert. Und all das, was uns zu Menschen macht: Angst. Liebe. Scham. Bedürfnis. Einsamkeit.
    Zum Paradies ist ein Wunderwerk literarischer Erfindungskraft und ein Kunstwerk menschlicher Gefühle. Seine außergewöhnliche Wirkung gründet in seinem Wissen um den Wunsch, jene zu beschützen, die wir lieben: Partner, Liebhaber, Kinder, Freunde - unsere Mitmenschen. Und den Schmerz, der nach uns greift, wenn wir das nicht können.`,
    kategorie: "Neu und Bestseller",
    "ISBN/GTIN": "978-3-546-10051-9",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Claassen Verlag",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "11.01.2022",
    Gewicht: "875 g",
    ArtikelNr: "19648141",
    Genre: "Belletristik",
    menge:13
  },
  {
    titel: "Einer von euch",
    autor: "Martin, Suter",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783257071689/COPL/Suter-Martin/Einer-von-euch.jpg?sq=4",
    preis: "26,00",
    sprache: "Deutsch",
    seiten: "384",
    beschreibung: `Bastian Schweinsteiger, der Held des WM-Finales 2014 in Rio, ist auch der Held des neuen Romans von Martin Suter. Der Autor erzählt uns Wahres und fast Wahres aus dem Leben des Mannes, dem es nicht in die Wiege gelegt war, alles zu erreichen, was man als Fußballer erreichen kann. Und er verrät uns auch, wie Basti dennoch so erfolgreich wurde. Nur so viel sei verraten: nicht aus Ehrgeiz. Aus Freude am Erfolg.`,
    kategorie: "Neu und Bestseller",
    "ISBN/GTIN": "978-3-257-07168-9",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Diogenes",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "26.01.2022",
    ArtikelNr: "19543813",
    Genre: "Belletristik",
    menge:19
  },
  {
    titel: "Strömung",
    autor: "Jakob, Augstein",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783351039493/COPL/Augstein-Jakob/Str%C3%B6mung.jpg?sq=2",
    preis: "22,00",
    sprache: "Deutsch",
    seiten: "301",
    beschreibung: `Dass alte Gewissheiten schwinden, dass die Welt sich schneller ändert, als er es für möglich gehalten hätte, wird Misslinger ausgerechnet in den USA klar, dem Ort, der für ihn immer noch für Freiheit und eine bessere Zukunft steht. Hier verschwimmen die Grenzen von Traum und Wirklichkeit, und Misslinger realisiert, dass ihm sein Leben längst entglitten ist.
    In seinem grandiosen literarischen Debüt erzählt Jakob Augstein eindringlich von einem Mann unserer Zeit, deren Konturen zwischen politischen Umbrüchen, neuen Ideen und alten Bedrohungen immer schwerer auszumachen sind.`,
    kategorie: "Neu und Bestseller",
    "ISBN/GTIN": "978-3-351-03949-3",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Aufbau-Verlag",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "17.01.2022",
    Gewicht: "20 g",
    ArtikelNr: "16430740",
    Genre: "Belletristik",
    menge:20
  },
  {
    titel: "Liebe in Zeiten des Hasses",
    autor: "Florian, Illies",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783103970739/COPL/Illies-Florian/Liebe-in-Zeiten-des-Hasses.jpg?sq=13",
    preis: "24,00",
    sprache: "Deutsch",
    seiten: "432",
    beschreibung: `»Lesen Sie bitte dieses Buch, es ist hinreißend. Ich habe so viel Neues erfahren, über die Liebe, die Kunst und das Grauen.« Ferdinand von Schirach
    In einem virtuosen Epochengemälde erweckt Florian Illies die dreißiger Jahre, dieses Jahrzehnt berstender politischer und kultureller Spannungen, zum Leben.
    Als Jean-Paul Sartre mit Simone de Beauvoir im Kranzler-Eck in Berlin Käsekuchen isst, Henry Miller und Anaïs Nin wilde Nächte in Paris und »Stille Tage in Clichy« erleben, F. Scott Fitzgerald und Ernest Hemingway sich in New York in leidenschaftliche Affären stürzen, fliehen Bertolt Brecht und Helene Weigel wie Katia und Thomas Mann ins Exil. Genau das ist die Zeit, in der die Nationalsozialisten die Macht in Deutschland ergreifen, Bücher verbrennen und die Gewalt gegen Juden beginnt.
    1933 enden die »Goldenen Zwanziger« mit einer Vollbremsung. Florian Illies führt uns zurück in die Epoche einer singulären politischen Katastrophe, um von den größten Liebespaaren der Kulturgeschichte zu erzählen: In Berlin, Paris, im Tessin und an der Riviera stemmen sich die großen Helden der Zeit gegen den drohenden Untergang. Eine mitreißend erzählte Reise in die Vergangenheit, die sich wie ein Kommentar zu unserer verunsicherten Gegenwart liest: Liebe in Zeiten des Hasses.`,
    kategorie: "Empfehlungen",
    "ISBN/GTIN": "978-3-10-397073-9",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "S.Fischer Verlag GmbH",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "27.10.2021",
    Gewicht: "640g",
    ArtikelNr: "19765871",
    Genre: "Sachbuch",
    menge:14
  },
  {
    titel: "Das NEINhorn und die SchLANGEWEILE",
    autor: "Marc-Uwe, Kling",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783551521286/COPL/Kling-Marc-Uwe/Das-NEINhorn-und-die-SchLANGEWEILE.jpg?sq=6",
    preis: "13,00",
    sprache: "Deutsch",
    seiten: "54",
    beschreibung: `Das NEINhorn und die KönigsDOCHter, die hatten einen Streit ...
    ... aber beide wissen nicht mehr, worum es geht.
    Als sich der NAhUND zum Erzieher aufspielt, wird es dem NEINhorn zu blöd und es zischt ab. Nach einer langen Wanderung landet es im dichten dunklen Dschungel, wo die SchLANGEWEILE von einem Assst runterhängt und allesss sssuper schlangweilig findet! Egal, was das NEINhorn vorschlägt, sie hat keine Schlussst darauf.
    Ob sich das NEINhorn von der SchLANGEWEILE einwickeln lässt?
    Mit phänomenaler Panorama-Ausklappseite Mit Schleiterspiel für noch mehr Spaß Mit Eintragseite zum Mitmachen Und mit vielen weiteren witzigen Tieren
    Eine neue witzige Geschichte von Marc-Uwe Kling über das schnickeldischnuckelig süße NEINhorn und seinen Umgang mit der SchLANGEWEILE - zum Vorlesen, Selbstlesen, Lachen und Entdecken. Großartig illustriert von Astrid Henn.`,
    kategorie: "Empfehlungen",
    "ISBN/GTIN": "978-3-551-52128-6",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Carlsen",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "29.11.2021",
    Gewicht: "441 g",
    ArtikelNr: "19761016",
    Genre: "Kinder- und Jugendbücher | Bilderbücher",
    menge:8
  },
  {
    titel: "Die Enkelin",
    autor: "Bernhard, Schlink",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783257071818/COPL/Schlink-Bernhard/Die-Enkelin.jpg?sq=4",
    preis: "25,00",
    sprache: "Deutsch",
    seiten: "368",
    beschreibung: `Birgit ist zu Kaspar in den Westen geflohen, für die Liebe und die Freiheit. Erst nach ihrem Tod entdeckt er, welchen Preis sie dafür bezahlt hat. Er spürt ihrem Geheimnis nach, begegnet im Osten den Menschen, die für sie zählten, erlebt ihre Bedrückung und ihren Eigensinn. Seine Suche führt ihn zu einer völkischen Gemeinschaft auf dem Land - und zu einem jungen Mädchen, das in ihm den Großvater und in dem er die Enkelin sieht. Ihre Welten könnten nicht fremder sein. Er ringt um sie.`,
    kategorie: "Empfehlungen",
    "ISBN/GTIN": "978-3-257-07181-8",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Diogenes",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "27.10.2021",
    ArtikelNr: "20323465",
    Genre: "Belletristik | Erzählende Literatur",
    menge:4
  },
  {
    titel: "Belletristik | Erzählende Literatur",
    autor: "Jonathan, Franzen",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783498020088/COPL/Franzen-Jonathan/Crossroads.jpg?sq=6",
    preis: "28,00",
    sprache: "Deutsch",
    seiten: "832",
    beschreibung: `Ein Roman über eine Familie am Scheideweg: über Sehnsucht und Geschwisterliebe, über Lügen, Geheimnisse und Rivalität. Der Auftakt zu Jonathan Franzens Opus magnum «Ein Schlüssel zu allen Mythologien» - einer Trilogie über drei Generationen einer Familie aus dem Mittleren Westen und einem der größten literarischen Projekte dieser Zeit.
    Es ist der 23. Dezember 1971, und für Chicago sind Turbulenzen vorhergesagt. Russ Hildebrandt, evangelischer Pastor in einer liberalen Vorstadtgemeinde, steht im Begriff, sich aus seiner Ehe zu lösen - sofern seine Frau Marion, die ihr eigenes geheimes Leben lebt, ihm nicht zuvorkommt. Ihr ältester Sohn Clem kehrt von der Uni mit einer Nachricht nach Hause zurück, die seinen Vater moralisch schwer erschüttern wird. Clems Schwester Becky, lange Zeit umschwärmter Mittelpunkt ihres Highschool-Jahrgangs, ist in die Musikkultur der Ära ausgeschert, während ihr hochbegabter jüngerer Bruder Perry, der Drogen an Siebtklässler verkauft, den festen Vorsatz hat, ein besserer Mensch zu werden. Jeder der an einem Scheideweg stehenden Hildebrandts sucht eine Freiheit, die jeder der anderen zu durchkreuzen droht.
    Jonathan Franzen ist berühmt für seine Gegenwartspanoramen mit ihren unvergesslich lebendigen Figuren. Jetzt, in «Crossroads», einer aus mehreren Perspektiven erzählten Geschichte, die sich im Großen und Ganzen an einem einzigen Wintertag entrollt, nimmt er den Leser mit in die Vergangenheit und beschwört eine Welt herauf, die in der heutigen noch nachhallt. Ein Familienroman von beispielloser Kraft und Tiefe, mal komisch, mal zutiefst bewegend und immer spannungsreich: ein fulminantes Werk, in dem Jonathan Franzens Gabe, im Kleinen das Große zu zeigen, in Erscheinung tritt wie nie zuvor.
    «Jonathan Franzen ist einer der größten lebenden Schriftsteller, und seine Romane gehören zum Kanon der großen amerikanischen Familien- und Sozialepen.»
    DER SPIEGEL`,
    kategorie: "Empfehlungen",
    "ISBN/GTIN": "978-3-498-02008-8",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Rowohlt",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "05.10.2021",
    Gewicht: "971 g",
    ArtikelNr: "16402655",
    Genre: "Belletristik | Erzählende Literatur",
    menge:20
  },
  {
    titel: "Ottolenghi Test Kitchen - Shelf Love",
    autor: "Yotam, Ottolenghi",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783831042944/COPL/Ottolenghi-Yotam/Ottolenghi-Test-Kitchen---Shelf-Love.jpg?sq=10",
    preis: "24,95",
    sprache: "Deutsch",
    seiten: "256",
    beschreibung: `Entspannt kochen mit dem Ottolenghi-Team
    Für dieses außergewöhnliche Kochbuch hat Weltbestsellerautor Yotam Ottolenghi sein Test Kitchen-Team bestehend aus Noor Murad, Verena Lochmuller, Tara Wigley und Gitai Fischer zusammengetrommelt. Und sie zeigen, wie einfach es ist mit bereits vorhandenen Zutaten aus der eigenen Küche einfache und köstlich schmeckende Kreationen zu kochen und ihnen dabei den besonderen Ottolenghi-Twist zu geben!
    Simple Ottolenghi-Rezepte für den Alltag
    Bringen Sie mehr Schwung in Ihre Küche - und zwar einfach mit dem, was Sie zu Hause da haben! Ob cremiger Hummus, unkompliziertes One Pot Chicken oder Blumenkohl-Käse-Kuchen - dieses Ottolenghi-Kochbuch überzeugt mit 90 einfachen Alltagsrezepten, die dennoch raffiniert und köstlich schmecken. Der typische Wow-Effekt von Ottolenghi verleiht den Gerichten das gewisse Etwas: Freuen Sie sich auf vielfältige Aromen, kreative Vielseitigkeit und innovative Einflüsse des Ottolenghi Test Kitchen-Teams!
    - Einfach Alltagsrezepte mit Zutaten aus dem Küchenregal: Was kann man alles aus einer Dose Kichererbsen oder einem Beutel tiefgefrorener Erbsen zaubern? Die Antwort liefern die flexiblen und originellen Ottolenghi-Rezepte, die das Beste aus den Zutaten holen, die Ihnen zu Hause zur Verfügung stehen.
    - Originelle Anregungen aus der Profiküche der Ottolenghi Test Kitchen: Schaffen Sie sich Ihre eigene Testküche im Ottolenghi-Style und experimentieren Sie mit fantasievollen Gerichten, die flexibel abgewandelt werden können - wie z.B. Tabouleh-Bratlinge, Persische Kräuter-Feta-Taschen oder Blaubeeren-Zitronen-Sahne-Schnitten.
    - Das erste Buch der neuen Kochbuchserie von Ottolenghis grandiosem Test Kitchen-Team
    Innovative Alltagsrezepte im Ottolenghi-Style! Zusammen mit Ottolenghis Test Kitchen-Team zaubern Sie köstliche Gerichte, aus Zutaten, die Sie bereits zu Hause haben!`,
    kategorie: "Empfehlungen",
    "ISBN/GTIN": "",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "Dorling Kindersley Verlag",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "04.10.2021",
    Gewicht: "770 g",
    ArtikelNr: "19537777",
    Genre: "Themenkochbücher",
    menge:20
  },
  {
    titel: "Memoiren eines Irren",
    autor: "Gustave, Flaubert",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783446268456/COPL/Flaubert-Gustave/Memoiren-eines-Irren.jpg?sq=1",
    preis: "28,00",
    sprache: "Deutsch",
    seiten: "240",
    beschreibung: `Witzig, romantisch, bösartig - Gustave Flauberts erster Roman in neuer ÜbersetzungEin junger Bursche beobachtet unter den Sommergästen in Trouville eine Frau, die ihn fasziniert. Als er ihren Bademantel vor der Flut rettet und zurückbringt, verliebt er sich auf der Stelle. Maria jedoch ist zehn Jahre älter als er, hat einen Mann und eine kleine Tochter. Mit ungeheurer Leidenschaft erzählt der junge Flaubert in seinem ersten Roman die eigene Geschichte, die ihn für ein Leben geprägt hat. In der Neuübersetzung von Elisabeth Edl, mit Jugendbriefen und einem Kommentar, der den biografischen Hintergrund farbig sichtbar macht, sind die "Memoiren eines Irren" das Selbstporträt eines Künstlers als junger Mann, der zu seinem 200. Geburtstag als einer der Größten gefeiert wird.`,
    kategorie: "Klassiker",
    "ISBN/GTIN": "978-3-446-26845-6",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Gebunden",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "25.10.2021",
    Gewicht: "293 g",
    ArtikelNr: "16414403",
    Genre: "Belletristik | Erzählende Literatur",
    menge:11
  },
  {
    titel: "Vom Verachtetwerden oder Drei Guineen",
    autor: "Virginia, Woolf",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783311220053/COPL/Woolf-Virginia/Vom-Verachtetwerden-oder-Drei-Guineen.jpg?sq=1",
    preis: "24,00",
    sprache: "Deutsch",
    seiten: "256",
    beschreibung: `Immer wieder hat sich Virginia Woolf mit der Frauenfrage befasst. Am berühmtesten ist wohl ihr hellsichtiger Essay Ein Zimmer für sich allein (1929). In Vom Verachtetwerden, zehn Jahre spater erschienen, ist Woolfs Ton weniger ironisch, ihre Haltung unnachgiebiger. Kurz vor Ausbruch des Zweiten Weltkriegs fragt sie sich, wie Frauen einen Krieg verhindern sollen, wenn sie ausgeschlossen sind von Aufgaben in Offentlichkeit und Politik, und übt damit grundsatzliche Kritik am Patriarchat. Auf eindrückliche Weise verbindet Woolf hier schon früh das Private mit dem Politischen, den Aufstieg der Faschisten mit grundsatzlichen gesellschaftlichen Macht- und Denkstrukturen: Die Wurzel des Faschismus liege in der Vorherrschaft des Mannes in samtlichen Lebensbereichen. Aber Woolf kritisiert nicht nur, sondern entwirft auch ein utopisches Gesellschaftmodell, eine Welt, in der Frauen Familie und Erwerbstatigkeit verbinden, sich in Ausbildung und Beruf frei entfalten, wirtschaftliche Unabhangigkeit und intellektuelle Freiheit erreichen: So konnten Frauen für dieselbe Sache arbeiten und kampfen wie Manner, auf Augenhohe mit ihnen. Woolfs noch heute hochaktueller Essay macht deutlich, dass Terror, Unrecht, Autoritarismus nur dann wirklich aus der Welt zu schaffen sind, wenn sie auch im »Kleinen« erkannt und bekampft werden.`,
    kategorie: "KLassiker",
    "ISBN/GTIN": "978-3-311-22005-3",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Kampa Verlag",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "23.09.2021",
    ArtikelNr: "19605553",
    Genre: "Belletristik | Erzählende Literatur",
    menge:13
  },
  {
    titel: "Aufzeichnungen aus einem toten Haus",
    autor: "Fjodor M., Dostojewski",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783446265738/COPL/Dostojewski-Fjodor-M./Aufzeichnungen-aus-einem-toten-Haus.jpg?sq=2",
    preis: "36,00",
    sprache: "Deutsch",
    seiten: "544",
    beschreibung: `Fjodor M. Dostojewskis großer autobiographischer Roman in neuer ÜbersetzungAm Anfang steht ein Mord: Alexánder Petrówitsch Gorjántschikow wird zu zehn Jahren Zwangsarbeit verurteilt. Der verwöhnte Adelige kommt nach Sibirien ins Lager. Der Schock von Verbrechen und Strafe verändert ihn zutiefst, und so beginnt er den Bericht über das, was ihm und seinen Leidensgefährten Tag für Tag widerfährt. Dostojewski schreibt aus eigenem Erleben: 1849 wurde er wegen revolutionärer Umtriebe zum Tode verurteilt, nach einer Scheinhinrichtung deportiert und verbrachte vier Jahre in Ketten. "Aufzeichnungen aus einem toten Haus" gehört zu seinen größten Büchern. Nach Tolstois "Krieg und Frieden" (Preis der Leipziger Buchmesse) hat Barbara Conrad nun auch dieses Meisterwerk neu übersetzt.`,
    kategorie: "Klassiker",
    "ISBN/GTIN": "978-3-446-26573-8",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Hanser",
    Erscheinungsjahr: "2020",
    Erstverkaufstag: "09.03.2020",
    Gewicht: "340 g",
    ArtikelNr: "16275045",
    Genre: "Belletristik | Erzählende Literatur",
    menge:17
  },
  {
    titel: "Little Women",
    autor: "Louisa May, Alcott",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783150113578/COPL/Alcott-Louisa-May/Little-Women.jpg?sq=4",
    preis: "36,00",
    sprache: "Deutsch",
    seiten: "592",
    beschreibung: `Sisters are forever! Über die Freundschaft von vier Schwestern »Little Women« - das sind die vier Schwestern March, und es ist die Geschichte einer Schriftstellerin, die nach Unabhängigkeit strebte und dabei einen Welterfolg schuf. Louisa May Alcott legte viel von sich selbst in Jo, die zweitälteste der vier Schwestern, und lässt auch sie von einer Karriere als Schriftstellerin träumen. Zwar ist das - wie so vieles andere - für eine Frau in der zweiten Hälfte des 19. Jahrhunderts nicht leicht, doch Jo, Meg, Beth und Amy gehen ihren Weg - gemeinsam und doch jede für sich. Mit Pinsel und Stift ist die Künstlerin Kera Till ins Neuengland der 1860er Jahre eingetaucht und hat die unterschiedlichen Charaktere der vier Schwestern mit schwärmerischen Details, floralen Elementen und verträumten Mustern eingefangen. In diesem Band finden sich Teil I und Teil II in vollständiger Neuübersetzung.»Ich will etwas Großartiges machen, etwas Heldenhaftes und Wundervolles, das nach meinem Tod unvergessen bleibt. Ich weiß noch nicht, was, aber ich halte die Augen offen und habe vor, euch alle eines Tages in Staunen zu versetzen. Ich glaube, ich werde Bücher schreiben und reich und berühmt werden.« (Jo March)`,
    kategorie: "Klassiker",
    "ISBN/GTIN": "978-3-15-011357-8",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Reclam",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "08.10.2021",
    ArtikelNr: "19896888",
    Genre: "Belletristik | Erzählende Literatur",
    menge:6
  },
  {
    titel: "Der Geldverleiher",
    autor: "Catherine, Gore",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783847704416/COPL/Fontane-Theodor/Der-Geldverleiher.jpg?sq=2",
    preis: "44,00",
    sprache: "Deutsch",
    seiten: "42",
    beschreibung: `Ein verblüffender Fund: Der junge Theodor Fontane entdeckt die viktorianische Erfolgsautorin Catherine Gore - Fontanes Übersetzung zeigt den werdenden Romancier.
    Catherine Gore (1799-1861), eine der meistgelesenen Autorinnen ihrer Zeit, porträtierte in ihrem 1842 in Fortsetzungen
    erschienenen Gesellschaftsroman Der Geldverleiher die englische Gesellschafts- und Finanzwelt. Mit drastischem Realismus und ihrer Beschreibungs- und Beobachtungskunst demaskiert sie eine Epoche voller Standesdünkel und antijüdischer Vorurteile. Theodor Fontane (1819-1898) hat den Roman der Zeitgenossin von der britischen Insel mit einer erstaunlichen Sprach- und Stilsicherheit übertragen - lange bevor er seine berühmten Romane schrieb, die ihn zum großen Klassiker des bürgerlichen Realismus machten.
    Auf Grundlage eines wiederentdeckten Typoskripts hat der Literaturwissenschaftler, Historiker und Fontane-Biograph
    Iwan-Michelangelo D'Aprile dieses übersetzerische Meisterstück aus Fontanes jungen Jahren ediert; sein Vorwort erhellt ein fehlendes Stück in Fontanes Gesamtwerk und bereichert uns um die Kenntnis seiner englischen Vorbilder.
    "Ein richtiger Schmöker. Ein äußerst interessantes Buch des Übergangs von der romantischen Schauergeschichte zum
    realistischen Roman ... Gore wollte unterhalten, und das ist ihr sehr gelungen." - Jürgen Kaube, Frankfurter Allgemeine Zeitung`,
    kategorie: "Klassiker",
    "ISBN/GTIN": "978-3-8477-0441-6",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "AB - Die Andere Bibliothek",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "19.10.2021",
    Gewicht: "733 g",
    ArtikelNr: "19774330",
    Genre: "Belletristik | Erzählende Literatur",
    menge:2
  },
  {
    titel: "Die Dorfschullehrerin",
    autor: "Eva, Völler",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783785727652/COPL/V%C3%B6ller-Eva/Die-Dorfschullehrerin.jpg?sq=14",
    preis: "14,99",
    sprache: "Deutsch",
    seiten: "448",
    beschreibung: `Eine junge Frau und die Herausforderung ihres Lebens
    1961: Als die Berliner Lehrerin Helene ihre neue Stelle in Hessen an der deutsch-deutschen Grenze antritt, begegnet man ihr im ländlichen, erzkatholischen Ort zunächst mit Ablehnung. Der althergebrachte drakonische Erziehungsstil, die Gleichgültigkeit der Kollegen - für die engagierte Helene ist es ein Kampf gegen Windmühlen. In Tobias, dem Landarzt, findet sie schließlich einen Verbündeten. Schon bald bedeutet er ihr mehr, als ihr lieb ist. Denn Helene hat ein Geheimnis - sie ließ sich nicht ohne Grund genau an diesen Ort versetzen ...`,
    kategorie: "Romane",
    "ISBN/GTIN": "978-3-7857-2765-2",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "Bastei Lübbe",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "26.11.2021",
    ArtikelNr: "19692490",
    Genre: "Belletristik | Erzählende Literatur",
    menge:20
  },
  {
    titel: "Das Seidenraupenzimmer",
    autor: "Sayaka, Murata",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783351037932/COPL/Murata-Sayaka/Das-Seidenraupenzimmer.jpg?sq=2",
    preis: "20,00",
    sprache: "Deutsch",
    seiten: "256",
    beschreibung: `Der neue Roman nach dem Bestseller »Die Ladenhüterin« Der neue Roman von Japans Erfolgsautorin Sayaka Murata erzählt die Geschichte von Natsuki und ihrem Cousin Yu, die sich jung verlieben und gemeinsam gegen eine Welt verbünden, die ihnen beileibe nicht nur Gutes will. Im alten Farmhaus der Familie, in dem früher die Seidenraupen ihren Dienst verrichteten, sind sie glücklich, denn sie sind beieinander. 20 Jahre später geht Natsuki an diesen Ort zurück ... Die Magie dieses abgründigen Romans spinnt uns ein in einen irisierenden Kokon der Fremdheit und entlässt uns schließlich in eine Realität, in der alles möglich ist. Sayaka Muratas Roman »Die Ladenhüterin« war eine literarische Sensation aus Japan, die auch die deutschen Leserinnen und Leser im Sturm erobert hat: Eine Außenseiterin findet als Angestellte eines 24-Stunden-Supermarkts ihre wahre Bestimmung. »Das Seidenraupenzimmer« erzählt die Geschichte von Außenseitern, die darum kämpfen, ihren Platz in der Welt zu finden, noch konsequenter: Wie Murata das Psychogramm eines Missbrauchsopfers überführt in eine gänzlich eigenständige Erzählung, die die Grenzen der Realität einreißt und neu bestimmt, ist beeindruckend - und die so überraschenden Wege der Freundschaft und Liebe, in der die Versehrten Zuflucht finden, sind umso tröstlicher und berührender. »Sehr lustig, aufregend beunruhigend und vollkommen überraschend.« Sally Rooney über »Die Ladenhüterin«`,
    kategorie: "Romane",
    "ISBN/GTIN": "978-3-351-03793-2",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Aufbau-Verlag",
    Erscheinungsjahr: "2020",
    Erstverkaufstag: "15.06.2020",
    Gewicht: "394 g",
    ArtikelNr: "16729235",
    Genre: "Belletristik | Erzählende Literatur",
    menge:6
  },
  {
    titel: "Die Surrealistin",
    autor: "Michaela, Carter",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783463000015/COPL/Carter-Michaela/Die-Surrealistin.jpg?sq=2",
    preis: "22,00",
    sprache: "Deutsch",
    seiten: "528",
    beschreibung: `Ein packender Roman über eine der wichtigsten Vertreterinnen des Surrealismus
    1937. Als die junge Engländerin Leonora Carrington den berühmten Surrealisten Max Ernst kennenlernt, ist er ein verheirateter Mann. Er führt sie in die Pariser Künstlerszene um Salvador Dalì und Pablo Picasso ein, und bald wird aus der leidenschaftlichen Affäre eine Liebesbeziehung. Das Paar zieht nach Südfrankreich, wo Carrington sich der Malerei verschreibt.
    Doch dann bricht der 2. Weltkrieg aus, Max Ernst wird von den Franzosen inhaftiert. Jahre später findet er ihr gemeinsames Haus leer vor. Er macht sich auf die Suche nach ihr. Doch Leonora hat mittlerweile begonnen, sich als Frau und Künstlerin zu emanzipieren. Auch von Max Ernst.`,
    kategorie: "Romane",
    "ISBN/GTIN": "978-3-463-00001-5",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Kindler",
    Erscheinungsjahr: "2020",
    Erstverkaufstag: "18.08.2020",
    Gewicht: "555 g",
    ArtikelNr: "17730759",
    Genre: "Belletristik | Erzählende Literatur",
    menge:2
  },
  {
    titel: "Worlds Collide",
    autor: "Anabelle, Stehl",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783736316638/COPL/Stehl-Anabelle/Worlds-Collide.jpg?sq=22",
    preis: "12,90",
    sprache: "Deutsch",
    seiten: "576",
    beschreibung: `Wenn Welten aufeinanderprallen ...
    Fiona hat es geschafft: Sie ist eine der erfolgreichsten Beauty-YouTuber:innen Englands, reist von Event zu Event und wird schon bald eine eigene Make-up-Linie herausbringen. Aber ihr Leben war nicht immer glamourös. Aufgewachsen in einer finanziell schwachen Familie nutzt sie ihre Reichweite, um anderen zu helfen. Ihr gutes Image gerät ins Wanken, als YouTuber Demian einen Skandal aufdeckt, in den Fiona unfreiwillig verwickelt ist. Bei einer Convention will sie ihren guten Ruf retten ... doch dann sitzt bei einem Panel ausgerechnet Demian neben ihr.
    »Es hat nur wenige Seiten gebraucht, um mich in dieses Buch zu verlieben.« THE BOOK DYNASTY über BREAKAWAY
    Auftaktband der WORLDS-Reihe rund um junge Influencer:innen in London von SPIEGEL-Bestseller-Autorin Anabelle Stehl`,
    kategorie: "New Adult",
    "ISBN/GTIN": "978-3-7363-1663-8",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "LYX",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "17.03.2022",
    Gewicht: "",
    ArtikelNr: "19691382",
    Genre: "Belletristik | Erzählende Literatur",
    menge:16
  },
  {
    titel: "Step into my Heart",
    autor: "Maren Vivien, Haase",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783734110030/COPL/Haase-Maren-Vivien/Step-into-my-Heart.jpg?sq=3",
    preis: "13,00",
    sprache: "Deutsch",
    seiten: "464",
    beschreibung: `Olivia und Dax: Entgegen aller Widerstände wollen sie ihre Träume wahr werden lassen - doch manchmal kommen Gefühle dazwischen.
    Olivia lebt für Hip-Hop und arbeitet hart daran, als Bühnentänzerin Fuß zu fassen - auch wenn ihre Eltern sie lieber beim Jurastudium sehen würden. Als sie einen Job bei einer Konzert-Tour ergattert, scheint das der ersehnte Durchbruch zu sein. Doch der Choreograf ist ausgerechnet Dax, der nach einem tragischen Unfall seine eigene Karriere als Tänzer beenden musste und Olivias Kumpel Austin die Schuld daran gibt. Verbittert und wütend hatte Dax sich damals von der Clique im Move District zurückgezogen, und so liegt nun bei der gemeinsamen Arbeit wieder reichlich Spannung in der Luft. Doch bald wird deutlich, dass dabei nicht nur die Geschehnisse aus der Vergangenheit und der Erfolgsdruck eine Rolle spielen, sondern auch aufkeimende Gefühle ...`,
    kategorie: "New Adult",
    "ISBN/GTIN": "978-3-7341-1003-0",
    Produktart: "Taschenbuch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "Blanvalet",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "15.11.2021",
    Gewicht: "513 g",
    ArtikelNr: "16412641",
    Genre: "Belletristik | Erzählende Literatur",
    menge:12
  },
  {
    titel: "Midnight Chronicles - Seelenband",
    autor: "Bianca, Iosivoni",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783736313491/COPL/Iosivoni-Bianca/Midnight-Chronicles---Seelenband.jpg?sq=27",
    preis: "14,90",
    sprache: "Deutsch",
    seiten: "464",
    beschreibung: `Sie will ihn nicht mehr lieben. Er will nichts anderes als sie zurückzugewinnen.
    Die Midnight Chronicles gehen weiter
    Ella hat am Tag des Blutbades alles verloren - und gibt sich selbst die Schuld daran. Als einziger Ausweg bleibt der Soul Huntress die Flucht nach Prag, weit weg von all dem, was sie quält. Doch dann steht ausgerechnet die eine Person wieder vor ihr, die sie mit allen Mitteln zu vergessen versucht: Wayne McKinley. Einst ihr süßestes Geheimnis, scheint Wayne nun nur noch eine schmerzvolle Erinnerung zu sein. Ella bleibt jedoch keine andere Wahl, als mit ihm zusammenzuarbeiten, um ihren Fehler vom Tag des Blutbades wiedergutzumachen. Auch auf die Gefahr hin, dass ihre Gefühle für den Hunter mit jeder gemeinsam verbrachten Minute stärker werden.
    "Dieses Buch hat mich mit allem, was es zu bieten hat, in den Bann gezogen und fassungslos zurückgelassen. Die Geschichte fesselt, das Setting fasziniert jedes Mal aufs Neue, und die Protagonisten muss man einfach lieben." BOOKWORMIII über DUNKELSPLITTER
    Band 4 der Reihe trägt den Titel SEELENBAND und erzählt die Geschichte von Ella und Wayne.`,
    kategorie: "New Adult",
    "ISBN/GTIN": "",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "LYX",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "23.02.2022",
    ArtikelNr: "16464508",
    Genre: "Belletristik | Science Fiction, Fantasy",
    menge:10
  },
  {
    titel: "Cassardim 3: Jenseits der Tanzenden Nebel",
    autor: "Julia, Dippel",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783522507226/COPL/Dippel-Julia/Cassardim-3-Jenseits-der-Tanzenden-Nebel.jpg?sq=4",
    preis: "17,00",
    sprache: "Deutsch",
    seiten: "464",
    beschreibung: `Der dritte und finale Band der Trilogie von Fantasy-Queen Julia DippelDer Kaiser ist tot, doch Amaias Status als Goldene Erbin ist nach wie vor umstritten. Sie steht zwischen der Tradition und einer Revolution - größer, als Cassardim sie je gesehen hat. Noár ist bemüht, sie aus der Schusslinie zu halten, aber Amaia verfolgt eigene Pläne. Sie muss das wachsende Chaos aufhalten, das von ihrem frisch vermählten Ehemann Besitz ergreift. Um ihn, Cassardim und die Menschenwelt zu retten, versammelt sie auf eigene Faust die Erben aller Reiche um sich und begibt sich mit ihnen auf die gefährliche Suche nach einem neuen Juwel der Macht. Ein Wettlauf gegen die Zeit beginnt, an dessen Ende sie nicht nur ihre große Liebe verlieren könnte ...`,
    kategorie: "New Adult",
    "ISBN/GTIN": "978-3-522-50722-6",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Planet! in der Thienemann-Esslinger Verlag GmbH",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "25.11.2021",
    Gewicht: "772 g",
    ArtikelNr: "19765904",
    Genre: "Kinder- und Jugendbücher",
    menge:20
  },
  {
    titel: "Words I Keep",
    autor: "Josi, Wismar",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783453425200/COPL/Wismar-Josi/Words-I-Keep.jpg?sq=4",
    preis: "13,00",
    sprache: "Deutsch",
    seiten: "400",
    beschreibung: `Es gibt Worte, an die man sich für immer erinnern möchte
    Die schüchterne Studentin und Buchbloggerin Emely lebt zusammen mit ihrer älteren Schwester Cassidy im wunderschönen Amber Falls in den Rocky Mountains. Cas, ihre Bookstagram-Community und ihre besten Freunde Lexie und Will sind für Em das Wichtigste im Leben. Als sie dem attraktiven, aber undurchschaubaren David begegnet, fühlt sie es sofort: die Aufregung des Neuen, das Knistern des ersten Verliebtseins. Jedes Mal, wenn sie sich begegnen, sprühen die Funken. Doch die Beziehung mit ihm verändert Em und treibt einen Keil zwischen sie und Cas. Kann er der Richtige sein, wenn er ihr Leben so durcheinanderbringt? Em muss sich entscheiden, oder sie verliert alles. Gibt es Happy Ends doch nur in Büchern und nicht im echten Leben?`,
    kategorie: "New Adult",
    "ISBN/GTIN": "978-3-453-42520-0",
    Produktart: "Taschenbuch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "Heyne",
    Erscheinungsjahr: "2022",
    Erstverkaufstag: "10.01.2022",
    Gewicht: "529 g",
    ArtikelNr: "16415036",
    Genre: "Belletristik",
    menge:10
  },
  {
    titel: "Barbarotti und der schwermütige Busfahrer",
    autor: "Hakan, Nesser",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783442771424/COPL/Nesser-H%C3%A5kan/Barbarotti-und-der-schwerm%C3%BCtige-Busfahrer.jpg?sq=4",
    preis: "12,00",
    sprache: "Deutsch",
    seiten: "416",
    beschreibung: `Gegen Inspektor Barbarottis Polizeikollegin - und neue Lebensgefährtin - Eva Backman wird in Stockholm intern ermittelt. Sie musste bei einem Einsatz zur Schusswaffe greifen, um Schlimmeres zu verhindern, was für einen der Beteiligten allerdings böse endete. Um Abstand zu gewinnen, beschließen Barbarotti und Backman, sich in die herbstliche Abgeschiedenheit Gotlands zurückzuziehen. Doch die Ruhe ist trügerisch. Barbarottis kriminalistische Instinkte werden geweckt, als er in einem Fahrradfahrer jenen rätselhaften Busfahrer zu erkennen glaubt, der vor sechs Jahren Opfer eines Verbrechens wurde, ohne dass man seine Leiche je gefunden hätte ...`,
    kategorie: "Krimis & Thriller",
    "ISBN/GTIN": "978-3-442-77142-4",
    Produktart: "Taschenbuch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "btb",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "09.11.2021",
    Gewicht: "360 g",
    ArtikelNr: "19596098",
    Genre: "Belletristik | Spannung | Krimis, Thriller, Spionage",
    menge:16
  },
  {
    titel: "Rehragout-Rendezvous",
    autor: "Rita, Falk",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783423262736/COPL/Falk-Rita/Rehragout-Rendezvous.jpg?sq=42",
    preis: "16,95",
    sprache: "Deutsch",
    seiten: "304",
    beschreibung: `»Was gibt's zum Essen?«
    »Nix. Die Oma kocht nicht mehr.«
    Zefix! Was ist denn in die Eberhofer-Weiber gefahren? Die Oma beschließt nach gefühlten 2000 Kuchen und noch mehr Schweinsbraten, Semmelknödeln und Kraut, sich der häuslichen Pflichten zu entledigen - und fortan zu chillen. Ausgerechnet an Weihnachten! Und seit die Susi ihre Karriere als stellvertretende Bürgermeistern verfolgt, fühlt sich der Sex mit ihr im schicken Neubau für den Franz an, als hätten sie ihn gratis zu den Esszimmermöbeln dazu bekommen. Zu allem Übel wird dann auch noch der Steckenbiller Lenz vermisst. Der Franz soll gefälligst eine Vermisstenanzeige aufgeben, die Mooshammer Liesl befürchtet das Schlimmste. Nur: Eine Leiche ist weit und breit nicht in Sicht. Damit steht der Eberhofer vor einer schier unlösbaren Aufgabe.`,
    kategorie: "Krimis & Thriller",
    "ISBN/GTIN": "978-3-423-26273-6",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "DTV",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "17.09.2021",
    ArtikelNr: "17373617",
    Genre: "Belletristik | Spannung | Krimis, Thriller, Spionage",
    menge:3},
  {
    titel: "Rue de Paradis",
    autor: "Alexander, Oetker",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783455012125/COPL/Oetker-Alexander/Rue-de-Paradis.jpg?sq=7",
    preis: "16,00",
    sprache: "Deutsch",
    seiten: "288",
    beschreibung: `Die große Bestseller-Reihe geht weiter: In der Rue de Paradis, einer Straße zwischen Ozean und Austernbucht, gerät Luc Verlain in ein Dickicht aus Lügen, Neid und lange gehüteten Geheimnissen.
    Bei einer schweren Sturmflut wird in einem kleinen Ort auf der Halbinsel Cap Ferret eine ganze Straße Opfer der Wassermassen, auch eine alte Frau stirbt in jener Nacht. Tatsächlich hätte hier, in der Rue de Paradis, nie gebaut werden dürfen. Nun müssen alle Häuser weg und die Bewohner umgesiedelt werden, aus ihrem Idyll am Ende der Welt. Luc Verlain soll in der aufgeheizten Stimmung vermitteln und findet sich bald in seinem kniffligsten Fall wieder, genau in der Nacht, in der eine neue Sturmflut droht: Der Bürgermeister des Dorfes treibt tot im Wasser. War der Mord an ihm die Rache des Enkels der Toten aus der Sturmnacht? Oder ist einer der Menschen schuldig, deren Häuser abgerissen werden? Bald wird klar: Der reiche Politiker hatte nur noch Feinde in der Rue de Paradis.`,
    kategorie: "Krimis & Thriller",
    "ISBN/GTIN": "978-3-455-01212-5",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "Hoffmann und Campe",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "01.11.2021",
    Gewicht: "389 g",
    ArtikelNr: "19648294",
    Genre: "Belletristik | Spannung | Krimis, Thriller, Spionage",
    menge:2
  },
  {
    titel: "Eifersucht",
    autor: "Jo, Nesbo",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783550201523/COPL/Nesb%C3%B8-Jo/Eifersucht.jpg?sq=4",
    preis: "22,99",
    sprache: "Deutsch",
    seiten: "272",
    beschreibung: `Der neue Coup von Jo Nesbø - Über 6 Millionen verkaufte Krimis im deutschsprachigen Raum
    "Der König des skandinavischen Kriminalromans" The Times
    Sieben erstklassige Stories, ein Motiv
    Der Athener Ermittler Nikos Balli, ein Spezialist für das Mord-Motiv Eifersucht, ist seit dem Verlust seiner großen Liebe ein Getriebener. Auf der Insel Kalymnos soll er einen Vermissten finden, Julian. Er und sein Zwillingsbruder Franz waren in dieselbe Frau verliebt, Helena, Tochter eines Gastwirts der Insel. Es kam zum Streit, und seitdem hat man Julian nicht mehr gesehen. Sein Handtuch wurde am Strand gefunden, ist der junge Mann beim morgendlichen Schwimmen ertrunken?
    Balli ermittelt und stößt auf immer mehr Beweise, dass Franz seinen Bruder ermordet hat - aber dann wird Julian gefunden, gefesselt und entkräftet in einer Höhle. Doch wo ist Franz? Balli muss all sein Gespür aufbringen, seine eigene schmerzvolle Erfahrung nochmals durchleben, um den Kampf der Zwillinge um Helena zu stoppen ...`,
    kategorie: "Krimis & Thriller",
    "ISBN/GTIN": "978-3-550-20152-3",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Ullstein HC",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "01.11.2021",
    Gewicht: "434 g",
    ArtikelNr: "19811084",
    Genre: "Belletristik | Spannung | Krimis, Thriller, Spionage",
    menge:19
  },
  {
    titel: "Die unhöfliche Tote",
    autor: "S. J., Bennett",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783426227411/COPL/Bennett-S.-J./Die-unh%C3%B6fliche-Tote.jpg?sq=10",
    preis: "18,00",
    sprache: "Deutsch",
    seiten: "368",
    beschreibung: `England hat eine neue Queen of Crime: Königin Elizabeth ermittelt höchstpersönlich!
    »Die unhöfliche Tote« ist der 2. Teil der humorvollen cosy Krimi-Reihe mit Queen Elizabeth als heimlicher Detektivin.
    Queen Elisabeth ist wirklich not amused über den Ausgang des Brexit-Referendums. Das Letzte, was sie jetzt gebrauchen kann, sind weitere Sorgen - wie zum Beispiel das Fehlen eines ihrer Lieblingsgemälde oder eine Leiche, die am Pool von Buckingham Palace liegt ...
    Die Tote war eine langjährige Haushälterin, und hartnäckige Gerüchte über deren Unbeliebtheit verlangen nach diskreten Nachforschungen. So lässt die Queen wieder einmal nur vordergründig die Polizei und ihre Offiziellen agieren, im Hintergrund aber setzt sie ihre kluge Assistentin Rozie und ihre eigenen grauen Zellen ein. Als sich herausstellt, dass im Hofstaat seit längerer Zeit Drohbriefe kursieren, nimmt der Fall eine bedenkliche Wendung. Und was geht eigentlich in den geheimen Tunneln unter Londons Königspalästen vor ...?
    Auch Teil 2 von S. J. Bennetts hinreißender Krimi-Reihe sprüht vor Charme und britischem Humor.
    Ihren ersten Fall lösen Queen Elisabeth und ihre Sekretärin Rozie im cleveren cosy Krimi »Das Windsor-Komplott«.`,
    kategorie: "Krimis & Thriller",
    "ISBN/GTIN": "978-3-426-22741-1",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Droemer/Knaur",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "02.11.2021",
    Gewicht: "495 g",
    ArtikelNr: "19602049",
    Genre: "Belletristik | Spannung | Krimis, Thriller, Spionage",
    menge:9
  },
  {
    titel: "Das Ministerium für die Zukunft",
    autor: "Kim Stanley, Robinson",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783453321700/COPL/Robinson-Kim-Stanley/Das-Ministerium-f%C3%BCr-die-Zukunft.jpg?sq=1",
    preis: "17,00",
    sprache: "Deutsch",
    seiten: "720",
    beschreibung: `Von Barack Obama auf Twitter empfohlen!
    Indien, 2025. Das Land wird von einer gnadenlosen Hitzewelle heimgesucht, die Temperaturen erreichen mancherorts über 50 Grad. Hunderttausende Menschen sterben, manchmal werden ganze Stadtviertel ausgelöscht. Zu den Überlebenden gehört der Entwicklungshelfer Frank May. Schwer traumatisiert zieht er in die Schweiz, um mit denen abzurechnen, die seiner Meinung nach mitverantwortlich sind: dem Ministerium für die Zukunft, dessen Aufgabe es eigentlich ist, solche Katastrophen zu verhindern. In Mary Murphy, der Vorsitzenden des Ministeriums, findet Frank unerwartet eine Verbündete, die wie er gegen den Klimawandel kämpft - wenn auch mit anderen Mitteln ...`,
    kategorie: "Fantasy & Sci-Fi",
    "ISBN/GTIN": "978-3-453-32170-0",
    Produktart: "Taschenbuch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "Heyne",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "11.10.2021",
    Gewicht: "688 g",
    ArtikelNr: "16415021",
    Genre: "Belletristik | Science Fiction, Fantasy | Science Fiction",
    menge:3
  },
  {
    titel: "Snow Crash",
    autor: "Neal, Stephenson",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783596705597/COPL/Stephenson-Neal/Snow-Crash.jpg?sq=2",
    preis: "16,99",
    sprache: "Deutsch",
    seiten: "576",
    beschreibung: `Die Erfindung des Metaverse durch SF-Visionär Neal Stephenson.
    Visionär und rasend schnell erzählt: Das zentrale Werk des Cyberpunks jetzt in neuer Übersetzung.
    Hiro Protagonist war mal Programmierer, aber seit auch hier die Konzerne alles gleichgeschaltet haben, zieht er jeden Bullshit-Job vor: Pizza-Auslieferer für die Mafia. Oder Information Broker für die ehemalige CIA.
    Wichtiger als die echte Welt ist für ihn ohnehin das Metaverse, ein virtueller Ort, an dem sich die Menschen mit ihren selbst gestalteten Avataren treffen. Dort begegnet er auch zum ersten Mal der Droge »Snow Crash«. Das Besondere: Snow Crash ist ein Computervirus, der auch Menschen befallen kann. Zusammen mit seiner Partnerin Y. T. ermittelt Hiro - und kommt einer Verschwörung auf die Spur, die bis in die menschliche Vorgeschichte zurückreicht.
    Für Leserinnen von William Gibson, Richard Morgan und Fans von Cyberpunk 2077.`,
    kategorie: "Fantasy & Sci-Fi",
    "ISBN/GTIN": "978-3-596-70559-7",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "FISCHER Tor",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "27.10.2021",
    Gewicht: "533 g",
    ArtikelNr: "19766373",
    Genre: "Belletristik | Science Fiction, Fantasy | Science Fiction",
    menge:5
  },
  {
    titel: "Supernova",
    autor: "Cixin, Liu",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783453320314/COPL/Liu-Cixin/Supernova.jpg?sq=2",
    preis: "14,99",
    sprache: "Deutsch",
    seiten: "512",
    beschreibung: `Der letzte Tag der Menschheit ist angebrochen. Eine gewaltige Strahlenwolke, ausgelöst durch eine Sternexplosion acht Jahre zuvor, wird schon bald alle Menschen über dreizehn Jahren töten. Seit acht Jahren läuft der Countdown, und seitdem werden die Kinder und Jugendlichen der Welt auf eine Zukunft allein vorbereitet. Einige von ihnen jedoch wollen gar nicht so weitermachen wie zuvor. Sie träumen von einer neuen, einer besseren Zukunft für sich und ihren Planeten. Dies ist ihre Geschichte ...`,
    kategorie: "Fantasy & Sci-Fi",
    "ISBN/GTIN": "978-3-453-32031-4",
    Produktart: "Taschenbuch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "Heyne",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "13.12.2021",
    Gewicht: "650 g",
    ArtikelNr: "18922370",
    Genre: "Belletristik | Science Fiction, Fantasy | Science Fiction",
    menge:20
  },
  {
    titel: "Outpost - Der Posten",
    autor: "Dmitry, Glukhovsky",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783453321779/COPL/Glukhovsky-Dmitry/Outpost---Der-Posten.jpg?sq=1",
    preis: "20,00",
    sprache: "Deutsch",
    seiten: "416",
    beschreibung: `Russland in der nahen Zukunft. Nach dem Krieg sind ganze Landstriche verseucht, die Flüsse vergiftet. Die einzelnen Städte haben kaum noch Kontakt zur Regierung in Moskau. Schon seit Jahren harrt Jegor im Außenposten in Jaroslawl aus. Sein Stiefvater Polkan, der Kommandant des Postens, macht ihm das Leben schwer, und die schöne Michelle interessiert sich nicht für ihn. Jegor träumt von der Welt jenseits der Eisenbahnbrücke, auf der anderen Seite des Flusses. Doch schon seit Jahrzehnten ist niemand mehr über diese Brücke gekommen. Bis heute ...`,
    kategorie: "Fantasy & Sci-Fi",
    "ISBN/GTIN": "978-3-453-32177-9",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Heyne",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "11.10.2021",
    Gewicht: "590 g",
    ArtikelNr: "19595665",
    Genre: "Belletristik | Science Fiction, Fantasy | Science Fiction",
    menge:10
  },
  {
    titel: "Algorytmica",
    autor: "Marion, Herzog",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783453424517/COPL/Herzog-Marion/Algorytmica.jpg?sq=1",
    preis: "16,00",
    sprache: "Deutsch",
    seiten: "432",
    beschreibung: `Wir schreiben das 24. Jahrhundert: Nach einer globalen Katastrophe haben sich die Überlebenden in riesige unterirdische Bunkeranlagen, sogenannte Archen, zurückgezogen. Dank hochmoderner Technologie und fähiger Programmierer sind die Arche-Bewohner vierundzwanzig Stunden am Tag in virtuelle Welten eingeloggt und können so vergessen, dass sie tief unter der Erdoberfläche in winzigen Zellen an lebenserhaltende Systeme angeschlossen sind. Dann kommt es eines Tages zu einem Black-out, die Systeme fallen aus und es wird klar, wie verletzlich die unterirdische Gesellschaft eigentlich ist. Die Informatikstudentin Kaja wittert eine Verschwörung, aber niemand nimmt sie ernst. Sie erhält jedoch Unterstützung von unerwarteter Seite: Liam Turner ist ein brillanter Kopf, der Verbindungen ins Darknet hat, und er glaubt Kaja. Und tatsächlich kommen die beiden einem gewaltigen Komplott auf die Spur ...`,
    kategorie: "Fantasy & Sci-Fi",
    "ISBN/GTIN": "978-3-453-42451-7",
    Produktart: "Taschenbuch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "Heyne",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "13.12.2021",
    Gewicht: "564 g",
    ArtikelNr: "19596070",
    Genre: "Belletristik | Science Fiction, Fantasy | Science Fiction",
    menge:15
  },
  {
    titel: "Sensibel",
    autor: "Svenja, Flaßpöhler",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783608983357/COPL/Fla%C3%9Fp%C3%B6hler-Svenja/Sensibel.jpg?sq=6",
    preis: "20,00",
    sprache: "Deutsch",
    seiten: "240",
    beschreibung: `»Sensibilität ist eine zivilisatorische Errungenschaft. Im Kampf um Anerkennung unterdrückter Gruppen spielt sie eine wichtige Rolle. Aber sie kann auch vom Progressiven ins Regressive kippen. Über diese Dialektik müssen wir nachdenken, um die gesellschaftliche Polarisierung zu überwinden.«
    Svenja Flaßpöhler
    Mehr denn je sind wir damit beschäftigt, das Limit des Zumutbaren neu zu justieren. Wo liegt die Grenze des Sagbaren? Ab wann ist eine Berührung eine Belästigung? Svenja Flaßpöhler tritt einen Schritt zurück und beleuchtet den Glutkern des Konflikts: die zunehmende Sensibilisierung des Selbst und der Gesellschaft.
    Menschheitsgeschichtlich steht die Sensibilisierung für Fortschritt: Menschen schützen sich wechselseitig in ihrer Verletzlichkeit, werden empfänglicher für eigene und fremde Gefühle, lernen, sich in fremde Schicksale hineinzuversetzen und mit anderen zu solidarisieren. Doch diese Entwicklung hat eine Kehrseite: Anstatt uns zu verbinden, zersplittert die Sensibilität die Gesellschaft. Erleben wir gerade den Kipppunkt fortschreitender Sensibilisierung? Svenja Flaßpöhler erzählt die Geschichte des sensiblen Selbst aus philosophischer Perspektive, beleuchtet die zentralen Streitfragen der Zeit und arbeitet den Grund für die prekäre Schieflage heraus: Weil die Widerstandskraft bis heute mit kalter Verpanzerung assoziiert wird, gilt sie als Feindin der Sensibilität. Aber stimmt das? »Sensibel« ist ein hochaktuelles, philosophisches und gleichzeitig unterhaltsames Buch, das die Sensibilität dialektisch durchleuchtet und zu dem Schluss kommt: Die Resilienz ist die Schwester der Sensibilität. Die Zukunft meistern können sie nur gemeinsam.`,
    kategorie: "Sachbücher & Ratgeber",
    "ISBN/GTIN": "978-3-608-98335-7",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Klett-Cotta",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "20.10.2021",
    Gewicht: "330 g",
    ArtikelNr: "19602392",
    Genre: "Sachbuch | Politik, Gesellschaft, Wirtschaft | Gesellschaft",
    menge:20
  },
  {
    titel: "Nachruf auf mich selbst.",
    autor: "Harald, Welzer",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783103971033/COPL/Welzer-Harald/Nachruf-auf-mich-selbst..jpg?sq=4",
    preis: "22,00",
    sprache: "Deutsch",
    seiten: "288",
    beschreibung: `Bestseller-Autor Harald Welzer stellt fest, dass unsere Kultur kein Konzept vom Aufhören hat. Deshalb baut sie Autobahnen und Flughäfen für Zukünfte, in denen es keine Autos und Flughäfen mehr geben wird. Und sie versucht, unsere Zukunftsprobleme durch Optimierung zu lösen, obwohl ein optimiertes Falsches immer noch falsch ist. Damit verbaut sie viele Möglichkeiten, das Leben durch Weglassen und Aufhören besser zu machen. Diese Kultur hat den Tod genauso zur Privatangelegenheit gemacht, wie sie die Begrenztheit der Erde verbissen ignoriert.
    Harald Welzer zeigt in einer faszinierenden Montage aus wissenschaftlichen Befunden, psychologischen Einsichten und persönlichen Geschichten, wie man aus den Absurditäten dieser gesellschaftlichen Entwicklung herausfindet. Man muss rechtzeitig einen Nachruf auf sich selbst schreiben, damit man weiß, wie man gelebt haben will.`,
    kategorie: "Sachbücher & Ratgeber",
    "ISBN/GTIN": "978-3-10-397103-3",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "S.Fischer Verlag GmbH",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "06.10.2021",
    Gewicht: "405 g",
    ArtikelNr: "19766438",
    Genre: "Sachbuch | Politik, Gesellschaft, Wirtschaft | Gesellschaft",
    menge:18},
  {
    titel: "Hier gehts lang - das ist dran! Klasse 7-10",
    autor: "Corinne, Keller",
    image:
      "https://www.kulturkaufhaus.de/annotstream/2244000318484/COPL/Keller-Corinne/Hier-gehts-lang---das-ist-dran-Klasse-7-10.jpg?sq=15",
    preis: "13,99",
    sprache: "Deutsch",
    beschreibung: `Als Lehrer kennen Sie Momente wie diese: Sie möchten, dass Ihre Schüler ohne Diskussionen in unterschiedlichen Gruppen gut zusammenarbeiten, im Klassenrat problemlos bestimmte Aufgaben übernehmen und dass im Klassenzimmer eine konstruktive Arbeitsatmosphäre herrscht. Im Schulalltag werden diese wiederkehrenden Situationen oft verbal gelöst. Aber das ständige Reden geht auf die Stimme und verhallt gelegentlich ungehört in Schülerohren. Daher finden Sie hier eine Fülle von Karten und Schildern, mit denen Sie ihren täglichen Unterricht effektiv und stimmschonend strukturieren können. Nach dem Motto "Bilder sagen mehr als 1000 Worte" sehen Ihre Schüler sofort und unmissverständlich, wer zu welcher Gruppe gehört, wer auf die Einhaltung der Klassenratsregeln achtet oder ob der Lärmpegel so akzeptabel ist. Die Illustrationen sind auf Schüler im Alter von ca. 13 bis 16 Jahren abgestimmt.`,
    kategorie: "Sachbücher & Ratgeber",
    "ISBN/GTIN": "9783403402107",
    Produktart: "E-Book",
    Einbandart: "Electronic Book",
    Verlag: "AOL-Verlag",
    Erscheinungsjahr: "2011",
    Erstverkaufstag: "01.02.2011",
    Dateigroesse: "5891 Kbytes",
    ArtikelNr: "2533083",
    Genre: "Schule und Lernen",
    menge:20
  },
  {
    titel: "Entscheidungstage",
    autor: "Stephan, Lamby",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783406774331/COPL/Lamby-Stephan/Entscheidungstage.jpg?sq=23",
    preis: "22,00",
    sprache: "Deutsch",
    seiten: "382",
    beschreibung: `DIE NERVENSCHLACHT UMS KANZLERAMT
    Deutschland erlebt dramatische politische Veränderungen. Nach einem Wahljahr mit zahlreichen Richtungswechseln wird die Parteienlandschaft durch die Bundestagswahl kräftig umgepflügt. Es gibt überraschende Aufstiege und schmerzhafte Abstürze. Aber es geht um weit mehr als um einzelne Karrieren. Die künftige Regierung steht vor immensen Herausforderungen - wegen des Klimawandels, der Pandemie, des gewaltigen Reformstaus, auch wegen des Auseinanderdriftens der Gesellschaft.
    Stephan Lamby untersucht das politische Leben in Deutschland seit einem Vierteljahrhundert. Seine Langzeitbeobachtungen dauern monate-, manchmal jahrelang. Seit Dezember 2020 hat er sich auf die Spuren der drei Kanzlerkandidat:innen begeben. Er konnte hinter die Kulissen der Kampagnen von SPD, Union und Grünen blicken, mit Olaf Scholz, Armin Laschet, Annalena Baerbock, Robert Habeck und ihren Wahlkampfmanagern viele exklusive Gespräche führen und sie aus der Nähe beobachten. Auch mit Christian Lindner, Markus Söder und vielen anderen sprach er ausführlich. Lamby erlebte hautnah mit, wie das Momentum beim Kampf ums Kanzleramt schlagartig hin und her wechselte - und lernte das Personal verstehen, das Deutschland in den nächsten Jahren führen wird. Sein Buch erklärt, wie es zu diesem ungewöhnlichen Bundestagswahlergebnis kommen konnte. Lamby blickt dabei auch auf frühere Kampagnen und Wahlkämpfer zurück, die er ebenfalls aus der Nähe beobachtete: von Kohl über Merkel bis Steinbrück und Schulz. Seine investigative Reportage ist nicht nur die fällige Chronik einer epischen Entscheidungsschlacht, sondern auch eine zeitlose Anatomie von Machtmenschen unter äußerster Anspannung.
    Machtkampf hautnah - ein Blick hinter die Kulissen der deutschen Spitzenpolitik
    Der Autor hat exklusiv alle drei Kanzlerkandidat:innen begleitet
    Vom renommierten Langzeitbeobachter der deutschen Spitzenpolitik und «Journalist des Jahres» 2018`,
    kategorie: "Sachbücher & Ratgeber",
    "ISBN/GTIN": "978-3-406-77433-1",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Beck",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "25.10.2021",
    Gewicht: "618 g",
    ArtikelNr: "20420874",
    Genre: "Sachbuch | Politik, Gesellschaft, Wirtschaft | Politik",
    menge:15
  },
  {
    titel: "1000 Jahre Freud und Leid",
    autor: "Weiwei, Ai",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783328602316/COPL/Ai-Weiwei/1000-Jahre-Freud-und-Leid.jpg?sq=4",
    preis: "38,00",
    sprache: "Deutsch",
    seiten: "416",
    beschreibung: `Einer der größten Künstler unserer Zeit erzählt sein Leben vor dem Hintergrund der Geschichte Chinas
    Ai Weiwei gehört zu den bekanntesten Künstlern unserer Zeit. In »1000 Jahre Freud und Leid« schildert er erstmals seinen außerordentlichen künstlerischen Werdegang vor dem Hintergrund der Geschichte seiner Familie in China. Schon als Junge erlebte er die Verbannung und Demütigung seines Vaters Ai Qing, einst ein Vertrauter Maos und Chinas einflussreichster Dichter, der im Zuge der Kulturrevolution als »Rechtsabweichler« gebrandmarkt wurde. Diese Erfahrungen prägten Ai Weiweis Schaffen und seine politischen Überzeugungen. Er beschreibt die schwierige Entscheidung, seine Familie zu verlassen, um für ein Kunststudium in die USA zu gehen, wo er sich u. a. mit Allen Ginsberg anfreundete und künstlerische Inspiration fand. Offen erzählt er von seinem Aufstieg zu einem Star der internationalen Kunstwelt, der aufgrund seiner Menschenrechtsaktivitäten jedoch immer stärker ins Visier des chinesischen Regimes geriet, das ihn schließlich 2011 mehrere Monate inhaftierte. Die sehr persönlichen und vom Künstler selbst reich illustrierten Erinnerungen geben nicht nur einen fesselnden Einblick in Ai Weiweis Leben und Arbeiten, sie sind zugleich Mahnung, die Meinungsfreiheit immer wieder neu zu verteidigen.`,
    kategorie: "Sachbücher & Ratgeber",
    "ISBN/GTIN": "978-3-328-60231-6",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Penguin Verlag München",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "02.11.2021",
    Gewicht: "732 g",
    ArtikelNr: "16417108",
    Genre: "Sachbuch | Politik, Gesellschaft, Wirtschaft",
    menge:12
  },
  {
    titel: "Die Hüterin der Drachen",
    autor: "Curatoria, Draconis",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783791374833/COPL/Draconis-Curatoria/Die-H%C3%BCterin-der-Drachen.jpg?sq=3",
    preis: "26,00",
    sprache: "Deutsch",
    seiten: "80",
    beschreibung: `Der ultimative Drachen-Führer: Geheimnisvolle Drachen und wo sie zu finden sind
    Willkommen auf der Drachen-Arche!`,
    kategorie: "Kinder- und Jugendbücher",
    "ISBN/GTIN": "978-3-7913-7483-3",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Prestel",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "20.09.2021",
    Gewicht: "989 g",
    ArtikelNr: "19596035",
    Genre: "Kinder- und Jugendbücher | Sachbücher, Sachbilderbücher",
    menge:20
  },
  {
    titel: "You will be the death of me",
    autor: "Karen M., McManus",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783570166062/COPL/McManus-Karen-M./You-will-be-the-death-of-me.jpg?sq=6",
    preis: "20,00",
    sprache: "Deutsch",
    seiten: "416",
    beschreibung: `Drei ehemalige Freunde. Ein Zufallstreffen. Ein Mord.
    Ivy, Mateo und Cal waren einmal befreundet, jetzt haben sie nichts mehr miteinander gemein. Aber als Cal zu spät zur Schule kommt und dort auf Ivy und Mateo trifft, scheint das die Gelegenheit zu sein, eine alte Tradition wiederaufleben zu lassen: einen Tag blau machen. Bei ihrem spontanen Ausflug in die Stadt sichten sie einen vierten Schüler auf Abwegen und folgen ihm - mitten hinein in einen Tatort. Ivy, Cal und Mateo kennen den Toten, der vor ihnen liegt - und eigentlich sollten sie jetzt die Polizei rufen. Doch sie alle haben eine Verbindung zu dem Toten. Und etwas zu verbergen. War ihr Zufallstreffen wirklich ein Zufall?`,
    kategorie: "Kinder- und Jugendbücher",
    "ISBN/GTIN": "978-3-570-16606-2",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "cbj",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "13.12.2021",
    Gewicht: "580 g",
    ArtikelNr: "20346206",
    Genre: "Kinder- und Jugendbücher | Jugendbücher",
    menge:19
  },
  {
    titel: "Alea Aquarius 7. Im Bannkreis des Schwurs",
    autor: "Tanya, Stewner",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783751201698/COPL/Stewner-Tanya/Alea-Aquarius-7.-Im-Bannkreis-des-Schwurs.jpg?sq=4",
    preis: "18,00",
    sprache: "Deutsch",
    seiten: "464",
    beschreibung: `Liebe, Freundschaft, Abenteuer - und Sehnsucht nach einem Wiedersehen: Der siebte Band von Alea Aquarius! Diesmal machen sich Alea und Lennox über Land auf den Weg zum Loreley-Felsen. Dort vermuten die beiden Aleas Zwillingsschwester Anthea. Werden die Zwillinge sich tatsächlich endlich treffen? Und wird es dadurch gelingen, Aleas Meermädchen-Fähigkeiten zu reaktivieren?`,
    kategorie: "Kinder- und Jugendbücher",
    "ISBN/GTIN": "978-3-7512-0169-8",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Oetinger",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "29.09.2021",
    Gewicht: "754 g",
    ArtikelNr: "19436457",
    Genre: "Kinder- und Jugendbücher | Kinderbücher",
    menge:20
  },
  {
    titel: "Die Kackwurstfabrik",
    autor: "Marja, Baseler",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783954701889/COPL/Baseler-Marja/Die-Kackwurstfabrik.jpg?sq=3",
    preis: "15,00",
    sprache: "Deutsch",
    seiten: "48",
    beschreibung: `Unser Körper ist eine faszinierende Kackwurstfabrik auf zwei Beinen. Zusammen mit den Kindern Pim und Polly machen wir einen Rundgang durch diese Fabrik - vom Kontrollraum ganz oben über das Säurebad des Magens und die achterbahnartige Fahrt durch den Darm bis hinunter zu den Pförtnern des Enddarms. Wegen Überlastung und Verstopfung steht die Kackwurstfabrik allerdings kurz vor dem Aus. Pim und Polly sind fest entschlossen, sie zu retten.Am Bild einer Fabrik mit all ihren Abteilungen und Maschinen wird hier mit vielen lustigen Wimmelbildern und Info-Kästen erklärt, was bei der Verdauung passiert.Vom Bissen im Mund bis zur Wurst im Klo - eine spannende Werkbesichtigung unseres Verdauungsapparats`,
    kategorie: "Kinder- und Jugendbücher",
    "ISBN/GTIN": "978-3-95470-188-9",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Klett Kinderbuch Verlag",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "06.12.2021",
    ArtikelNr: "1907256",
    Genre: "Kinder- und Jugendbücher",
    menge:17
  },
  {
    titel: "Book Rebels",
    autor: "Annette, Pehnt",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783446271326/COPL/Pehnt-Annette/Book-Rebels.jpg?sq=2",
    preis: "22,00",
    sprache: "Deutsch",
    seiten: "192",
    beschreibung: `Von Iphigenie über Pippi Langstrumpf bis zu Meggie aus "Tintenherz": "Book Rebels" versammelt 75 literarische Heldinnen aus unterschiedlichen Zeiten - zum Entdecken und Schmökern.Diese Frauen- und Mädchenfiguren aus der Literatur sind wahre Rebellinnen. Sie sind stark, beweisen Mut und gehen ihre eigenen Wege. Sie stehen zu ihren Schwächen, müssen gegen Rückschläge kämpfen und lassen sich dennoch nicht unterkriegen. Ihre Geschichten kann man in Büchern nachlesen. In einzigartigen Porträts werden diese literarischen Heldinnen vorgestellt: Von Iphigenie über Alice, Heidi und Pippi bis hin zu Katniss und Starr versammelt dieses Buch 75 außergewöhnliche Mädchen und Frauen aus unterschiedlichen Epochen und Kulturen. Eine inspirierende Lektüre zum Entdecken und Schmökern, eindrucksvoll illustriert von Felicitas Horstschäfer.`,
    kategorie: "Kinder- und Jugendbücher",
    "ISBN/GTIN": "978-3-446-27132-6",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Hanser",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "25.10.2021",
    Gewicht: "617 g",
    ArtikelNr: "16414404",
    Genre: "16414404",
    menge:12
  },
  {
    titel: "Shelter",
    autor: "Ursula, Poznanski",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783743200517/COPL/Poznanski-Ursula/Shelter.jpg?sq=2",
    preis: "19,95",
    sprache: "Deutsch",
    seiten: "432",
    beschreibung: `Die Idee war völlig verrückt und sie wären niemals darauf gekommen, wenn die Party nicht so aus dem Ruder gelaufen wäre. Aus einer Katerlaune heraus erfinden Benny und seine Freunde eine irre Geschichte über außerirdische Besucher und verbreiten sie im Internet. Gespannt wartet die Clique ab, was passiert. Zu ihrer eigenen Überraschung nehmen immer mehr Menschen die Sache für bare Münze und Bennys Versuche, alles aufzuklären, bringen ihn schon bald in Lebensgefahr.
    Was, wenn du dir eine völlig absurde Geschichte ausdenkst, sie zum Spaß in die Welt setzt und plötzlich glauben alle daran? Ein schockierender Thriller über einen Streich, der zur verwirrenden Realität wird.
    Ursula Poznanskis neuer und hochaktueller Bestseller ist eine wache Analyse der Mechanismen moderner Verschwörungstheorien und ihrer Auswirkungen.`,
    kategorie: "Jugendbücher",
    "ISBN/GTIN": "978-3-7432-0051-7",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Loewe Verlag",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "13.10.2021",
    Gewicht: "648 g",
    ArtikelNr: "19888573",
    Genre: "Kinder- und Jugendbücher",
    menge:9
  },
  {
    titel: "Das Reich der sieben Höfe - Dornen und Rosen",
    autor: "Sarah J., Maas",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783423718493/COPL/Maas-Sarah-J./Das-Reich-der-sieben-H%C3%B6fe---Dornen-und-Rosen.jpg?sq=8",
    preis: "11,95",
    sprache: "Deutsch",
    seiten: "480",
    beschreibung: `Sie hat ein Leben genommen. Jetzt muss sie mit ihrem Herz dafür bezahlen.
    Die junge Jägerin Feyre wird in das sagenumwobene Reich der Fae entführt. Nichts ist dort, wie es scheint. Sicher ist nur eins: Sie muss einen Weg finden, um ihre Liebe zu retten. Oder ihre ganze Welt ist verloren.`,
    kategorie: "Jugendbücher",
    "ISBN/GTIN": "978-3-423-71849-3",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "DTV",
    Erscheinungsjahr: "2020",
    Erstverkaufstag: "22.05.2020",
    ArtikelNr: "16491439",
    Genre: "Kinder- und Jugendbücher",
    menge:3
  },
  {
    titel: "Das Reich der sieben Höfe - Silbernes Feuer",
    autor: "Sarah J., Maas",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783423763349/COPL/Maas-Sarah-J./Das-Reich-der-sieben-H%C3%B6fe---Silbernes-Feuer.jpg?sq=39",
    preis: "21,00",
    sprache: "Deutsch",
    seiten: "816",
    beschreibung: `Nesta und Cassian: Das neue Traumpaar am Fantasyhimmel
    Feyres Schwester Nesta war schon immer stolz, wütend und nachtragend - und seit sie gegen ihren Willen eine High Fae wurde, fällt es ihr schwer, ihren Platz am Hof der Nacht zu finden. Ausgerechnet Cassian soll Nesta nun dabei helfen, ihr Schicksal zu akzeptieren. Doch die plötzliche Nähe zu ihm stellt Nesta vor eine beinahe unerträgliche Herausforderung, denn noch immer kann und will sie ihren Gefühlen für Cassian nicht nachgeben.
    Als dem Reich der Fae erneut ein Krieg droht, liegt es an Nesta, drei magische Artefakte zu finden - um das Schlimmste zu verhindern. Doch die Suche bringt nicht nur dunkle Machenschaften ans Licht, sondern auch Nestas magische Fähigkeiten, die eine ungeahnte Gefahr darstellen ...
    Alte Gefährten, neue Freunde und noch gefährlichere Feinde - der neue Roman von Bestsellerautorin Sarah J. Maas ist mitreißender, leidenschaftlicher und magischer denn je!
    Kennen Sie bereits die weiteren Serien von Sarah J. Maas bei dtv?
    »Throne of Glass«
    »Crescent City«`,
    kategorie: "Jugendbücher",
    "ISBN/GTIN": "978-3-423-76334-9",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "DTV",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "20.10.2021",
    ArtikelNr: "19392179",
    Genre: "Kinder- und Jugendbücher",
    menge:22
  },
  {
    titel:
      "Das offizielle Harry Potter Koch- und Backbuch für Partys und Feste mit Rezepten und Kreativ-Ideen aus der Zauberwelt,",
    autor: "Jennifer, Carroll",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783845514307/COPL/Carroll-Jennifer/Das-offizielle-Harry-Potter-Koch--und-Backbuch-f%C3%BCr-Partys-und-Feste-mit-Rezepten-und-Kreativ-Ideen-aus-der-Zauberwelt.jpg?sq=5",
    preis: "28,00",
    sprache: "Deutsch",
    seiten: "192",
    beschreibung: `Jede Veranstaltung wird einfach magisch, wenn sie von der geheimnisvollen Zaubererwelt der Harry-Potter-Filme inspiriert ist!
    Und schon beim Lesen und Anschauen dieses umfangreichen, liebevoll gestalteten Handbuches steigt einem förmlich der Duft köstlicher Speisen in die Nase ...
    Mit diesem Werk können nun auch Muggel in den kulinarischen Kosmos von Harry, Hermine und Ron eintauchen, denn es enthält alles, um eine perfekte Party zum Thema Harry Potter zu planen und zauberhafte Feste zu organisieren: Rund 200 köstliche Rezepte, Bastelanregungen und Tipps zu Dekorationen, Einladungen und Spielen machen dieses opulente Buch zum Standardwerk jedes Fans. Gespickt mit zahlreichen Fotos, zauberhalten Abbildungen und lustigen Fakten sowie Einblicken hinter die Kulissen der Filme, bietet dieser umfassende Leitfaden eine Schritt-für-Schritt-Anleitung, wie man die perfekte Harry-Potter-Party organisiert.
    Der erste Teil konzentriert sich auf die Menüs und enthält über fünfzig Rezepte für festliche Speisen und Getränke, die auch die Herzen von Magiern und Hexen höher schlagen lassen, wenn sich in der großen Halle von Hogwarts die Tische wie von Zauberhand decken. Die herzhaften und süßen Kreationen greifen Figuren, Kreaturen, Artefakte und Orte aus den Filmen auf und beinhalten auch vegane, vegetarische, gluten- sowie zuckerfreie Optionen. Von Hogwarts speziellen Haus-Wraps bis hin zu Hagrids Happy-Birthday-Cupcakes werden alle Wünsche erfüllt.
    Teil zwei konzentriert sich auf die Planung und enthält Entwürfe für sechs Veranstaltungen zum Thema Zauberer, von einer Geburtstagsfeier mit buntem Hausmotto bis hin zu einer Halloween-Party im Verbotenen Wald. Jede Party enthält eine komplette Planungsstrategie sowie Ideen, Fotos und Anleitungen für Dekorationen, Einladungen, besondere Details, Aktivitäten und mehr.
    Viele Projekte enthalten außerdem kostenlos herunterladbare Vorlagen, die auf den Originalgrafiken aus den Filmen basieren.
    Dieses Buch macht Appetit aufs Feiern, welche Art von Fest Sie auch planen! Auch wenn Sie einfach nur Gäste oder Familie mit leckeren Koch- oder Backrezepten verwöhnen möchten - dieses Buch enthält alles, was Sie brauchen, damit Ihre nächste Veranstaltung so magisch wie eine Reise nach Hogwarts wird!
    Ein Muss für alle Harry Potter-Fans: Rund 200 Tipps für leckere Gerichte, Basteltipps und Anregungen für unvergessliche Feste! köstliche Koch- und Backrezepte - inspiriert von den reich gedeckten Tafeln in Hogwarts opulentes Standardwerk für alle Muggel, die in die geheimnisvolle Zaubererwelt eintauchen möchten`,
    kategorie: "Jugendbücher",
    "ISBN/GTIN": "978-3-8455-1430-7",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Nelson",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "29.11.2021",
    Gewicht: "1077 g",
    ArtikelNr: "19761482",
    Genre: "Kinder- und Jugendbücher",
    menge:20
  },
  {
    titel: "One Of The Good Ones",
    autor: "Maritza, Moulite",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783743211551/COPL/Moulite-Maritza/One-Of-The-Good-Ones.jpg?sq=1",
    preis: "14,95",
    sprache: "Deutsch",
    seiten: "416",
    beschreibung: `"Sie war doch eine von den Guten"
    Ausgerechnet Kezi! Happis große, hübsche, starke und kluge Schwester ist tot. Kezi hatte sich aktiv auf ihrem Youtube-Kanal für die Rechte Schwarzer Menschen eingesetzt. Und nun wurde sie selbst ein Opfer von Polizeigewalt nach einer Demonstration.
    Voller Trauer begibt sich Happi zusammen mit Freunden auf eine Reise, die noch von Kezi geplant worden ist. Quer durch die USA folgen sie dem Green Book, einem Reiseführer, der Schwarzen Reisenden während der Zeit der Rassentrennung angab, wo sie unbehelligt tanken, essen oder übernachten konnten.
    Kezi war eine "von den Guten", sagen die Leute. Aber ist ihr Tod deshalb besonders tragisch? Und was heißt das überhaupt?
    One of The Good Ones ist ein spannender Roadtrip durch das alte und neue Amerika und bricht auf unerwartete Weise mit allen unseren Erwartungen.
    Eine aufregende Reise durch die jüngere Geschichte der USA aus der Perspektive der afroamerikanischen Minderheit und ein begeisterndes Plädoyer für das Empowerment Schwarzer Menschen.`,
    kategorie: "Jugendbücher",
    "ISBN/GTIN": "978-3-7432-1155-1",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "Loewe Verlag",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "17.11.2021",
    Gewicht: "503 g",
    ArtikelNr: "19890064",
    Genre: "Kinder- und Jugendbücher",
    menge:10
  },
  {
    titel: "Asterix 39",
    autor: "Jean-Yves, Ferri",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783770424399/COPL/Ferri-Jean-Yves/Asterix-39.jpg?sq=10",
    preis: "12,00",
    sprache: "Deutsch",
    seiten: "48",
    beschreibung: `Mit "Asterix und der Greif" legt das Duo Jean-Yves Ferri und Didier Conrad sein fünftes gemeinsames Asterix-Album vor! Diesmal verschlägt es die Gallier ins Barbaricum, weit im wilden Osten.Nach einem verheißungsvollen Traum macht sich Miraculix mit Asterix, Obelix und Idefix auf die Reise ins Land der Sarmaten. Dort wohnt der Schamane Terrine mitsamt seinem Stamm und hat die Hilfe seines alten Freundes bitter nötig!Denn die Römer sind auf dem Vormarsch, um für Cäsar den sagenumwobenen Greif zu fangen, der in dieser Region hausen soll. Zu allem Übel ist in der eisigen Kälte der Taiga auch noch Miraculix' Zaubertrank gefroren und dadurch unbrauchbar geworden...`,
    kategorie: "Comics & Manga",
    "ISBN/GTIN": "978-3-7704-2439-9",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Ehapa Comic Collection",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "21.10.2021",
    Gewicht: "364 g",
    ArtikelNr: "16408235",
    Genre: "Belletristik | Comic, Cartoon, Humor, Satire",
    menge:5
  },
  {
    titel: "Im Spiegelsaal",
    autor: "Liv, Strömquist",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783964450623/COPL/Str%C3%B6mquist-Liv/Im-Spiegelsaal.jpg?sq=1",
    preis: "20,00",
    sprache: "Deutsch",
    seiten: "168",
    beschreibung: `Bereits 2003 schrieb die Philosophin Susan Bordo, dass wir in einem "Imperium der Bilder" leben. In den letzten Jahren wurde diese Theorie mehr und mehr zur Realität: Eine iPhone-Kamera in jeder Hand, und dank der weit verbreiteten Social-Media-Nutzung ertrinken wir in einer Flut der Bilder. Wir kommunizieren durch Bilder, wir verabreden uns mittels Bildern, wir berichten aus unserem Leben mit Bildern und wir erfahren über das Leben anderer durch Bilder.Wie hat sich unser Schönheitsempfinden dadurch verändert? Diese Frage wird hier in fünf Essays, die sich dem Thema jeweils aus einer anderen Perspektive nähern, untersucht. Die Schwedin Liv Strömquist ist ein Phänomen. Ihre augenzwinkernden, minutiös recherchierten Sachcomics gehören zu den meist verkauften Graphic Novels weltweit."Liv Strömquist entzaubert nicht nur Sexualität, sondern auch das Patriarchat. Und das tut sie auf sehr schlaue, lustige und schöne Art". Margarete Stokowski`,
    kategorie: "Comics & Manga",
    "ISBN/GTIN": "978-3-96445-062-3",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "avant-verlag",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "26.10.2021",
    ArtikelNr: "19897159",
    Genre: "Belletristik | Comic, Cartoon, Humor, Satire",
    menge:30
  },
  {
    titel: "Es kann nur eine geben",
    autor: "Carolin, Kebekus",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783462001747/COPL/Kebekus-Carolin/Es-kann-nur-eine-geben.jpg?sq=3",
    preis: "18,00",
    sprache: "Deutsch",
    seiten: "352",
    beschreibung: `»Ich will den Finger in die Wunde legen!« Carolin Kebekus über Frauen an der Spitze.
    Eigentlich klingt es ganz leicht: Frau ist begabt und klug, also kann sie es schaffen, ganz nach oben zu kommen. Aber oft genug ist der eine Platz schon besetzt, es scheint nämlich ein höchst dämliches Gesetz zu geben, das lautet: Eine Frau reicht, mehr brauchen wir nicht. Die große Komikerin, Sängerin, Schauspielerin und Feministin schreibt pointiert, unmissverständlich und gleichzeitig wahnsinnig komisch, dass die Zeit überreif ist, alte (Männer-)Gesetze auf den Müll zu werfen.
    Wohin man auch schaut, immer ist es die eine Frau, die sich durchsetzt. In der Bibel ist es die jungfräuliche Maria, damit fing das Unheil an. Im Märchen gibt es immer die eine Prinzessin, sehr schön und sehr blöd. Die sündige Eva aus der Bibel und die böse Stiefmutter oder Hexe lassen wir mal hübsch beiseite, denn die sollen nur als Beispiele dafür dienen, was passiert, wenn Frauen nach Macht streben: Sie werden aus dem Paradies geworfen oder verbrannt. Mit dieser Prägung entlässt man Frauen ins Leben und wundert sich dann über die ständige Konkurrenz unter Frauen um diese begrenzten Plätze. Dann wird so getan, als wären Frauen von Natur aus eben stutenbissig und selbst schuld an dieser Rivalität. Carolin Kebekus kommt diesem bösen Spuk auf die Spur, sie untersucht alte und neue Geschichten, um zu zeigen, warum uns Frauen eingetrichtert wird, dass wir um den einen Platz - im Fernsehen, in der Firma, im Karneval usw. - konkurrieren müssten.
    Ein Buch von höchster Wichtigkeit, das aufklärt und gleichzeitig unterhält.`,
    kategorie: "Comics & Manga",
    "ISBN/GTIN": "978-3-462-00174-7",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "Kiepenheuer & Witsch",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "07.10.2021",
    Gewicht: "436 g",
    ArtikelNr: "19895616",
    Genre: "Belletristik | Comic, Cartoon, Humor, Satire",
    menge:13
  },
  {
    titel: "Starman - David Bowie's Ziggy Stardust Years",
    autor: "Reinhard, Kleist",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783551793621/COPL/Kleist-Reinhard/Starman---David-Bowies-Ziggy-Stardust-Years.jpg?sq=5",
    preis: "25,00",
    sprache: "Deutsch",
    seiten: "176",
    beschreibung: `1972 erlebte die Geburt des Rock'n'Roll-Messias Ziggy Stardust, dessen provokantes Spiel mit sexueller Identität und Geschlechterrollen den Grundstein für David Bowies Aufstieg zum "einflussreichsten Popmusiker aller Zeiten" (New Musical Express) legte.
    Starman erzählt von Aufstieg und Fall des wohl berühmtesten Alter Egos der Musikgeschichte.
    Fesselnd verwebt Reinhard Kleist die Genese der schrillen Kunstfigur sowohl mit David Bowies glücklosem Bemühen in der Londoner Musikszene vor Ziggy Stardust wie auch mit seinem Ringen mit der eigenen Schöpfung auf dem Höhepunkt des Ruhms: Immer rasanter verwandelt sich Bowie selbst zum egozentrischen Rockstar, der an seinem ausschweifenden Lebensstil zu scheitern droht...
    Reinhard Kleists elegante und treffsichere Zeichnungen werden in Starman durch die Farbgebung von Thomas Gilke kongenial ergänzt.`,
    kategorie: "Comics & Manga",
    "ISBN/GTIN": "978-3-551-79362-1",
    Produktart: "Buch",
    Einbandart: "Gebunden",
    Verlag: "Carlsen",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "30.11.2021",
    Gewicht: "827 g",
    ArtikelNr: "19760775",
    Genre: "Belletristik | Comic, Cartoon, Humor, Satire | Comic",
    menge:20
  },
  {
    titel: "Sonne und Beton - Die Graphic Novel",
    autor: "Oljanna, Haus",
    image:
      "https://www.kulturkaufhaus.de/annotstream/9783446269613/COPL/Haus-Oljanna/Sonne-und-Beton---Die-Graphic-Novel.jpg?sq=5",
    preis: "18,00",
    sprache: "Deutsch",
    seiten: "280",
    beschreibung: `Platz 2 der Graphic Novel-Bestsellerliste: Ein glühend heißer Sommer. Vier Jungs in Neukölln. Eine folgenschwere Entscheidung. Die Graphic Novel zum Bestseller "Sonne und Beton" von Comedy-Superstar Felix LobrechtDie junge talentierte Zeichnerin Oljanna Haus hat sich von Felix Lobrechts von der Kritik gefeiertem Debütroman zu einer rasanten Graphic Novel inspirieren lassen. In schnellen Schnitten inszeniert sie die authentischen Dialoge und lässt die unerbittliche Welt der Hochhausschluchten erstehen.`,
    kategorie: "Comics & Manga",
    "ISBN/GTIN": "978-3-446-26961-3",
    Produktart: "Buch",
    Einbandart: "Kartoniert, Paperback",
    Verlag: "hanserblau",
    Erscheinungsjahr: "2021",
    Erstverkaufstag: "25.10.2021",
    Gewicht: "748 g",
    ArtikelNr: "16397032",
    Genre: "Belletristik | Comic, Cartoon, Humor, Satire | Comic",
    menge:10,
  },
];

export default books;